/* eslint-disable radix */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  DownOutlined,
  EditOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
  PrinterOutlined
} from '@ant-design/icons';
import {
  Badge,
  Button,
  Card,
  Col,
  DatePicker,
  Descriptions,
  Divider,
  Dropdown,
  Form,
  Grid,
  Input,
  InputNumber,
  Modal,
  Radio,
  Result,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  Tooltip,
  Typography,
  Upload,
  message
} from 'antd';
import { debounce } from 'lodash';
import * as moment from 'moment';
import React, { useContext, useEffect, useRef, useState } from 'react';
import 'react-credit-cards/es/styles-compiled.css';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import {
  Label,
  SubSubtitle,
  SubSubtitleStart,
  Subtitle,
  Title,
  TitleBar
} from '../../components';
import CalendarioPagosForm from '../../components/CalendarioPagosForm';
import CustomDatePicker from '../../components/CustomDatePicker';
import DescripcionPlan from '../../components/DescripcionPlan';
import LabelValidateMessage from '../../components/LabelValidateMessage';
import MetodoPago from '../../components/MetodoPago';
import ReconfirmarCIAModal from '../../components/ReconfirmarCIAModal';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import SolicitudPlanVigencia from '../../components/SolicitudPlanVigencia';
import StepperSolicitud from '../../components/StepperSolicitud';
import VigenciaForm from '../../components/VigenciaForm';
import InputMask from '../../components/input-mask';
import {
  CONFIG,
  ESTADOS,
  NACIONALIDADES,
  TIPOS_COMBUSTIBLE,
  TIPOS_USO_VEHICULO,
  TIPOS_USO_VEHICULO_TODOS,
  USER_STATES,
  compressionOptions
} from '../../constants';
import EmpresaContext from '../../context/empresa-context';
import SessionContext from '../../context/session-context';
import { useSolicitudContext } from '../../context/solicitud-context';
import UserContext from '../../context/user-context';
import {
  isEmpty,
  validateCedulaIdentidad,
  validateCedulaVerde,
  validateChapaProvisoria
} from '../../functions/images';
import {
  calcularDigitoVerificador,
  colores,
  consultarCliente,
  errorHandler,
  formatCelular,
  getCarouselData,
  getCoordenadasByDireccion,
  getDatosBCP,
  getDatosSetByRuc,
  getTable,
  heicAndheifConvert,
  myImageCompression,
  parseCelular,
  prefijos3Digitos,
  reconocerCombustible,
  transformarPropiedades,
  validarCaracterEspecial,
  validarCaracterTelefono
} from '../../utils';
import { getDatosPersonaByEmpresa, instanceRef } from '../../utils/axios';
import { formatoMonedaGenerico } from '../../utils/converters';
import BotonSiguiente from '../BotonSiguiente';
import '../Form.css';
import { CalendarioPagos, Vigencia } from '../personal/Descripciones';

const { useBreakpoint } = Grid;
const { Option } = Select;
const { RangePicker } = DatePicker;

const colStyles = {
  display: 'table',
  textAlign: 'center',
  justifyContent: 'center'
};

const maxWidth = 1096;

// lila #393182
// rojo #D8605D
// verde #8CEFD5
// amarillo #FBEB77
// gris #F3F4F3

export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

const beforeUpload = async (file, setLoading) => {
  setLoading(true);
  const isJpgOrPng =
    file.type === 'image/jpeg' ||
    file.type === 'image/heif' ||
    file.type === 'image/heic' ||
    file.type === 'image/png';
  if (!isJpgOrPng) {
    message.warning('El formato del archivo no está permitido.');
  }
  const isLt10M =
    file.size /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 <
    2;
  if (!isLt10M) {
    message.warning('El tamaño de la imagen debe ser inferior a 10MB.');
  }
  setLoading(false);
  return isJpgOrPng && isLt10M;
};

const steps = [
  {
    title: 'Paso 1',
    description: (
      <span>
        Elegí una <strong>Opción</strong>
      </span>
    )
  },
  {
    title: 'Paso 2',
    description: (
      <span>
        Subí las <strong>Fotos de tus Documentos</strong>
      </span>
    )
  },
  {
    title: 'Paso 3',
    description: (
      <span>
        Confirmá <strong>tus Datos</strong>
      </span>
    )
  },
  {
    title: 'Paso 4',
    description: (
      <span>
        ¡Confirmá tu <strong>Solicitud</strong>!
      </span>
    )
  }
];

const scrollToRef = (ref) => {
  if (ref && ref.current) {
    const headerOffset = 64;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = ref.current.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

export const CedulaAdelanteUpload = ({
  formatosImagen,
  cargado,
  setCargado,
  setLoading,
  setLoadingBefore,
  loading,
  uploadFile
}) => (
  <div>
    <Upload
      style={{ width: 'auto !important' }}
      name="avatar"
      accept={formatosImagen}
      listType="picture-card"
      className={`avatar-uploader ${cargado ? 'success' : 'error'}`}
      showUploadList={false}
      customRequest={(e) => uploadFile(e, 'CIA', setCargado, setLoading)}
      beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
      disabled={loading}
    >
      {cargado ? (
        <img src={cargado.imagen} alt="avatar" className="upload-img" />
      ) : (
        <div className="upload-img-wrapper">
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          {!loading && (
            <>
              <div className="ant-upload-text">(Frente)</div>
              <img
                src="/images/cedula_adelante.png"
                alt="avatar"
                style={{ width: '100%' }}
              />
            </>
          )}
        </div>
      )}
    </Upload>
  </div>
);

export const CedulaAtrasUpload = ({
  formatosImagen,
  cargado,
  setCargado,
  setLoading,
  setLoadingBefore,
  loading,
  uploadFile
}) => (
  <div>
    <Upload
      style={{ width: 'auto !important' }}
      name="avatar"
      accept={formatosImagen}
      listType="picture-card"
      className={`avatar-uploader ${cargado ? 'success' : 'error'}`}
      showUploadList={false}
      customRequest={(e) => uploadFile(e, 'CID', setCargado, setLoading)}
      beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
      disabled={loading}
    >
      {cargado ? (
        <img src={cargado.imagen} alt="avatar" className="upload-img" />
      ) : (
        <div className="upload-img-wrapper">
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          {!loading && (
            <>
              <div className="ant-upload-text">(Dorso)</div>
              <img
                src="/images/cedula_atras.png"
                alt="avatar"
                style={{ width: '100%' }}
              />
            </>
          )}
        </div>
      )}
    </Upload>
  </div>
);

export const CedulaVerdeAtrasUpload = ({
  formatosImagen,
  cargado,
  setCargado,
  setLoading,
  setLoadingBefore,
  loading,
  uploadFile,
  idCotizacion
}) => (
  <div>
    <Upload
      style={{ width: 'auto !important' }}
      name="avatar"
      accept={formatosImagen}
      listType="picture-card"
      className={`avatar-uploader ${cargado ? 'success' : 'error'}`}
      showUploadList={false}
      customRequest={(e) =>
        uploadFile(e, 'CVD', setCargado, setLoading, idCotizacion)
      }
      beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
      disabled={loading}
    >
      {cargado ? (
        <img src={cargado.imagen} alt="avatar" className="upload-img" />
      ) : (
        <div className="upload-img-wrapper">
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          {!loading && (
            <>
              <div className="ant-upload-text">(2- Datos del Vehículo)</div>
              <img
                src="/images/cedula_verde_atras.jpeg"
                alt="avatar"
                style={{ width: '100%' }}
              />
            </>
          )}
        </div>
      )}
    </Upload>
  </div>
);

export const CedulaVerdeAdelanteUpload = ({
  formatosImagen,
  cargado,
  setCargado,
  setLoading,
  setLoadingBefore,
  loading,
  uploadFile,
  idCotizacion
}) => (
  <div>
    <Upload
      style={{ width: 'auto !important' }}
      name="avatar"
      accept={formatosImagen}
      listType="picture-card"
      className={`avatar-uploader ${cargado ? 'success' : 'error'}`}
      showUploadList={false}
      customRequest={(e) =>
        uploadFile(e, 'CVA', setCargado, setLoading, idCotizacion)
      }
      beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
      disabled={loading}
    >
      {cargado ? (
        <img src={cargado.imagen} alt="avatar" className="upload-img" />
      ) : (
        <div className="upload-img-wrapper">
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          {!loading && (
            <>
              <div className="ant-upload-text">(1- Datos del Titular)</div>
              <img
                src="/images/cedula_verde_adelante.jpeg"
                alt="avatar"
                style={{ width: '100%' }}
              />
            </>
          )}
        </div>
      )}
    </Upload>
  </div>
);

const HabilitacionAdelanteUpload = ({
  formatosImagen,
  cargado,
  setCargado,
  setLoading,
  setLoadingBefore,
  loading,
  uploadFile
}) => (
  <div>
    <Upload
      style={{ width: 'auto !important', borderColor: 'red' }}
      name="avatar"
      accept={formatosImagen}
      listType="picture-card"
      className={`avatar-uploader ${cargado ? 'success' : 'error'}`}
      showUploadList={false}
      customRequest={(e) => uploadFile(e, 'HAD', setCargado, setLoading)}
      beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
      disabled={loading}
    >
      {cargado ? (
        <img src={cargado.imagen} alt="avatar" className="upload-img" />
      ) : (
        <div className="upload-img-wrapper">
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          {!loading && (
            <>
              <div className="ant-upload-text">(1- Datos del Titular)</div>
              <img
                src="/images/habilitacion_adelante.png"
                alt="avatar"
                style={{ width: '100%' }}
              />
            </>
          )}
        </div>
      )}
    </Upload>
  </div>
);

const HabilitacionAtrasUpload = ({
  formatosImagen,
  cargado,
  setCargado,
  setLoading,
  setLoadingBefore,
  loading,
  uploadFile
}) => (
  <div>
    <Upload
      style={{ width: 'auto !important' }}
      name="avatar"
      accept={formatosImagen}
      listType="picture-card"
      className={`avatar-uploader ${cargado ? 'success' : 'error'}`}
      showUploadList={false}
      customRequest={(e) => uploadFile(e, 'HAA', setCargado, setLoading)}
      beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
      disabled={loading}
    >
      {cargado ? (
        <img src={cargado.imagen} alt="avatar" className="upload-img" />
      ) : (
        <div className="upload-img-wrapper">
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          {!loading && (
            <>
              <div className="ant-upload-text">(2- Datos del Vehículo)</div>
              <img
                src="/images/habilitacion_atras.png"
                alt="avatar"
                style={{ width: '100%' }}
              />
            </>
          )}
        </div>
      )}
    </Upload>
  </div>
);

const CertificadoVentaUpload = ({
  formatosImagen,
  cargado,
  setCargado,
  setLoading,
  setLoadingBefore,
  loading,
  uploadFile
}) => (
  <div>
    <Upload
      style={{ width: 'auto !important', borderColor: 'red' }}
      name="avatar"
      accept={formatosImagen}
      listType="picture-card"
      className={`avatar-uploader ${cargado ? 'success' : 'error'}`}
      showUploadList={false}
      customRequest={(e) => uploadFile(e, 'CERV', setCargado, setLoading)}
      beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
      disabled={loading}
    >
      {cargado ? (
        <img src={cargado.imagen} alt="avatar" className="upload-img" />
      ) : (
        <div className="upload-img-wrapper">
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          {!loading && (
            <>
              <div className="ant-upload-text">Subir</div>
              <img
                src="/images/certificado_venta.jpg"
                alt="avatar"
                style={{ width: '100%' }}
              />
            </>
          )}
        </div>
      )}
    </Upload>
  </div>
);

const ChapaProvisoriaUpload = ({
  formatosImagen,
  cargado,
  setCargado,
  setLoading,
  setLoadingBefore,
  loading,
  uploadFile
}) => (
  <div>
    <Upload
      style={{ width: 'auto !important', borderColor: 'red' }}
      name="avatar"
      accept={formatosImagen}
      listType="picture-card"
      className={`avatar-uploader ${cargado ? 'success' : 'error'}`}
      showUploadList={false}
      customRequest={(e) => uploadFile(e, 'CP', setCargado, setLoading)}
      beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
      disabled={loading}
    >
      {cargado ? (
        <img src={cargado.imagen} alt="avatar" className="upload-img" />
      ) : (
        <div className="upload-img-wrapper">
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          {!loading && (
            <>
              <div className="ant-upload-text">Subir</div>
              <img
                src="/images/chapa_provisoria.jpg"
                alt="avatar"
                style={{ width: '100%' }}
              />
            </>
          )}
        </div>
      )}
    </Upload>
  </div>
);

const CertificadoNacionalizacionUpload = ({
  formatosImagen,
  cargado,
  setCargado,
  setLoading,
  setLoadingBefore,
  loading,
  uploadFile
}) => (
  <div>
    <Upload
      style={{ width: 'auto !important', borderColor: 'red' }}
      name="avatar"
      accept={formatosImagen}
      listType="picture-card"
      className={`avatar-uploader ${cargado ? 'success' : 'error'}`}
      showUploadList={false}
      customRequest={(e) => uploadFile(e, 'CERN', setCargado, setLoading)}
      beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
      disabled={loading}
    >
      {cargado ? (
        <img src={cargado.imagen} alt="avatar" className="upload-img" />
      ) : (
        <div className="upload-img-wrapper">
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          {!loading && (
            <>
              <div className="ant-upload-text">Subir</div>
              <img
                src="/images/certificado_nacionalizacion.jpg"
                alt="avatar"
                style={{ width: '100%' }}
              />
            </>
          )}
        </div>
      )}
    </Upload>
  </div>
);

const FormNew = ({
  cotizaciones,
  token,
  loading: loadingPlanes,
  loaded: loadedPlanes,
  onDebounce,
  debouncing
}) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { user, userState } = useContext(UserContext);
  const myRef = useRef(null);
  const scrollTop = () => setTimeout(() => scrollToRef(myRef));
  const { empresa, producto, empresaProducto } = useContext(EmpresaContext);
  const [productoCotizacion, setProductoCotizacion] = useState({});
  const [form] = Form.useForm();
  const [solicitado, setSolicitado] = useState(false);
  const [principalLoading, setPrincipalLoading] = useState(false);
  const [selectedCotizacion, setSelectedCotizacion] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState();
  const [selectedPlanTipo, setSelectedPlanTipo] = useState();
  const [loadingBefore, setLoadingBefore] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [loadingCertificadoVenta, setLoadingCertificadoVenta] = useState(false);
  const [loadingChapaProvisoria, setLoadingChapaProvisoria] = useState(false);
  const [
    loadingCertificadoNacionalizacion,
    setLoadingCertificadoNacionalizacion
  ] = useState(false);

  const [isDirty, setIsDirty] = useState(true);
  const [current, setCurrent] = useState(0);
  const [subpasoDocumentos, setSubpasoDocumentos] = useState(0);
  const [cedula1, setCedula1] = useState(''); // file upload
  const [cedula2, setCedula2] = useState(''); // file upload
  const [cedulaVerde1, setCedulaVerde1] = useState(''); // file upload
  const [cedulaVerde2, setCedulaVerde2] = useState(''); // file upload
  const [habilitacion1, setHabilitacion1] = useState(''); // file upload
  const [habilitacion2, setHabilitacion2] = useState(''); // file upload
  const [certificadoVenta, setCertificadoVenta] = useState(''); // file upload
  const [chapaProvisoria, setChapaProvisoria] = useState(''); // file upload
  const [
    cedulaVerdeFrontalValidacion,
    setCedulaVerdeFrontalValidacion
  ] = useState();
  const [
    cedulaVerdeDorsalValidacion,
    setCedulaVerdeDorsalValidacion
  ] = useState();
  const [idCotizacionActual, setIdCotizacionActual] = useState();
  const [modalCedulaVerdeInvalida, setModalCedulaVerdeInvalida] = useState(
    false
  );
  const [modalEstaEsTuChapa, setModalEstaEsTuChapa] = useState(false);
  const [isEditingModalChapa, setIsEditingModalChapa] = useState(false);
  const [textValueModalChapa, setTextValueModalChapa] = useState('');
  const [certificadoNacionalizacion, setCertificadoNacionalizacion] = useState(
    ''
  ); // file upload

  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [submodelos, setSubmodelos] = useState([]);
  const [anios, setAnios] = useState([]);

  const { descripcion: descripcionProducto } = productoCotizacion;
  let titulo = '';
  if (descripcionProducto) {
    titulo =
      current === 0
        ? `Cotización de Seguro - ${descripcionProducto}`
        : `Solicitá tu Seguro - ${descripcionProducto}`;
  }

  const [departamentos, setDepartamentos] = useState([]);
  const [distritos, setDistritos] = useState([]);
  const [coordenadasAsegurado, setCoordenadasAsegurado] = useState();
  const [datosContactoFromCID, setDatosContactoFromCID] = useState({});
  const [datosContactoFromCIA, setDatosContactoFromCIA] = useState({});
  const [datosExternosPersona, setDatosExternosPersona] = useState({});
  const [
    datosExternosPersonaImagenCID,
    setDatosExternosPersonaImagenCID
  ] = useState({});
  const [datosExternosVehiculoCVA, setDatosExternosVehiculoCVA] = useState({});

  const screens = useBreakpoint();
  const [esJuridica, setEsJuridica] = useState(false);
  const [tieneCV, setTieneCV] = useState(true);
  const [tieneHabilitacion, setTieneHabilitacion] = useState(false);
  const [soloNumCedula, setSoloNumCedula] = useState(false);
  const [cedulaManualForm] = Form.useForm();
  const noEsCliente = user && user['cognito:groups'][0] !== 'CLIENTE';

  const { collapsed } = useContext(SessionContext);
  let marginLeft = 0;
  if (collapsed !== undefined && screens.md === true) {
    marginLeft = collapsed ? 80 / 2 : 300 / 2;
  }
  const {
    solicitarRequest,
    changeData,
    smsEnviado,
    setDatosOriginales,
    datosOriginales,
    setDatosBCP,
    datosBCP,
    calendarioPagosContext,
    vigenciaPagosContext
  } = useSolicitudContext();
  const [cuestionario, setCuestionario] = useState({});
  const [endosoSwitch, setEndosoSwitch] = useState({});
  const [prefijoTelefono, setPrefijoTelefono] = useState('');
  const [sufijoTelefono, setSufijoTelefono] = useState('');
  const [prefijoTelEmpleador, setPrefijoTelEmpleador] = useState('');
  const [sufijoTelEmpleador, setSufijoTelEmpleador] = useState('');
  const [rucJuridicaBCP, setRucJuridicaBCP] = useState(false);
  const [vehiculoBCP, setVehiculoBCP] = useState(false);
  const [monedas, setMonedas] = useState();
  const [moneda, setMoneda] = useState();
  const [coincideCI, setCoincideCI] = useState();
  const [selectedMonedaPlan, setSelectedMonedaPlan] = useState();
  const [vigenciaSugeridaConfig, setVigenciaSugeridaConfig] = useState();
  const [loadingVigenciaSugerida, setLoadingVigenciaSugerida] = useState(false);
  const [vigenciaByAseguradoraList, setVigenciaByAseguradoraList] = useState([
    {
      aseguradora: null,
      config: null,
      vigencia: {
        desde: null,
        hasta: null,
        cantidad_dias: null
      },
      pagos: {
        cantidad_pagos: null,
        frecuencia: null
      }
    }
  ]);
  const [distritosTercero, setDistritosTercero] = useState([]);

  const [impresion, setImpresion] = useState(false);
  const [distritosZonaCirculacion, setDistritosZonaCirculacion] = useState([]);
  const [autorizaciones, setAutorizaciones] = useState(null);

  const [mostrarConfirmarCedula, setMostrarConfirmarCedula] = useState(false);
  const [numeroCedula, setNumeroCedula] = useState();
  const [numeroCedulaModificada, setNumeroCedulaModificada] = useState();
  const [confirmarCedulaLoading, setConfirmarCedulaLoading] = useState(false);
  const [formCedula] = Form.useForm();

  const datosImg = {};
  const founddatosBCP = {};
  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px'
  };
  const [fields, setFields] = useState({
    marca: null,
    modelo: null,
    submodelo: null,
    anio: null,
    monto: 0,
    chassis: null,
    chapa: null,
    color: undefined,
    otroColor: undefined,
    origen: null,
    anioFabricacion: null,
    anioInscripcion: null,
    combustible: null,
    tipoUso: null,
    ocupantes: null,
    id: null,
    nombres: null,
    nombre: null,
    apellido: null,
    prefix: '+595',
    celular: null,
    cedula: null,
    cedulaOrRuc: null,
    correo: null,
    sexo: undefined,
    lugarNacimiento: null,
    fechaNacimiento: null,
    domicilio: null,
    departamento: undefined,
    distrito: undefined,
    nacionalidad: undefined,
    estadoCivil: undefined,
    latitud: null,
    longitud: null,
    personaBCP: null,
    departamentoZonaCirculacion: null,
    distritoZonaCirculacion: null,

    ruc: null,
    profesion: null,
    ingresos: null,
    proveedoEstado: false,
    politicamenteExpuesto: false,
    trabajo: undefined,
    institucion: undefined,
    cargo: null,
    anioIngreso: null,
    empresaEmpleador: null,
    rucEmpleador: null,
    telefonoEmpleador: null,
    celularEmpleador: null,
    direccionEmpleador: null,

    formaPago: null,
    metodoPago: null,
    titularTarjeta: null,
    numeroTarjeta: null,
    vencimientoTarjeta: null,

    numeroCuenta: null,
    tercero: {
      nombres: null,
      cedula: null,
      ruc: null,
      celular: null,
      domicilio: null,
      correo: null,
      telefono: null
    },
    endoso: null
  });

  const validarCedulaIdentidad = React.useCallback(async () => {
    try {
      const data = {
        datosCIA: {
          cedula: datosContactoFromCIA.cedula,
          nombres: datosContactoFromCIA.nombres
        },
        datosCID: {
          cedula: datosContactoFromCID.cedula,
          nombres: datosContactoFromCID.nombres
        }
      };
      const response = await instanceRef.instance.post(`file/validar`, data);
      let coincide = false;
      if (response.data?.data) {
        coincide = response.data?.data;
      }
      setCoincideCI(coincide);
      return coincide;
    } catch (error) {
      setCoincideCI(false);
      return null;
    }
  }, [
    datosContactoFromCIA.cedula,
    datosContactoFromCIA.nombres,
    datosContactoFromCID.cedula,
    datosContactoFromCID.nombres
  ]);

  const verificarAutorizaciones = async (plan) => {
    try {
      setPrincipalLoading(true);
      if (plan) {
        const response = await instanceRef.instance.post(
          `autorizacion/config/consultar`,
          {
            planes: [plan]
          }
        );

        if (response.data?.data) {
          setAutorizaciones(response.data.data);
        }
        setPrincipalLoading(false);
        return response.data.data;
      }
      setPrincipalLoading(false);
      return {};
    } catch (err) {
      setPrincipalLoading(false);
      errorHandler(err);
      return {};
    }
  };

  const tieneAutorizacionPorTipo = (tipo) => {
    const controlesPorAutorizacion = autorizaciones.some((item) =>
      item.configs.some((config) => {
        if (tipo === 'ZONA') {
          if (
            config.tipo_validacion === tipo &&
            config.cP &&
            config.cP.length > 0
          ) {
            const controlDepartamento = config.cP.some(
              (control) => control.id_departamento && !control.eliminado
            );
            const controlDistrito = config.cP.some(
              (control) => control.id_distrito && !control.eliminado
            );
            const controlPoligono = config.cP.some(
              (control) => control.poligono && !control.eliminado
            );
            return (
              controlDepartamento ||
              controlDistrito ||
              (controlPoligono &&
                (Number(producto) === 4 ||
                  Number(producto) === 5 ||
                  Number(producto) === 6))
            );
          }
          return false;
        }
        return config.tipo_validacion === tipo;
      })
    );
    return controlesPorAutorizacion;
  };

  const getVigenciaSugeridaAndConfig = React.useCallback(async () => {
    if (empresa && producto && token) {
      setLoadingVigenciaSugerida(true);
      try {
        const response = await instanceRef.instance.get(
          `/cotizacion/vigencia-sugerida-config`,
          {
            params: {
              idEmpresa: empresa.id,
              idProducto: producto,
              token
            }
          }
        );
        setVigenciaSugeridaConfig(response.data?.data);
      } catch (err) {
        errorHandler(err, 'Error al cargar la solicitud');
      }
      setLoadingVigenciaSugerida(false);
    }
  }, [empresa, producto, token]);

  const formatosImagen = 'image/jpeg,image/heif,image/heic, image/png';

  const concatTelefono = (prefijo, sufijo) => {
    if (prefijo.length === 0 && sufijo.length === 0) {
      return null;
    }
    return prefijo.concat(` ${sufijo}`);
  };

  const getIngreso = (ingreso) => {
    switch (ingreso) {
      case '1':
        return 2000000;
      case '2':
        return 6000000;
      case '3':
        return 11000000;
      case '4':
        return 16000000;
      default:
        return 0;
    }
  };

  const getDescripcionesIngreso = (ingreso) => {
    switch (ingreso) {
      case '1':
        return '1.000.000 a 5.000.000';
      case '2':
        return '5.000.000 a 10.000.000';
      case '3':
        return '10.000.000 a 15.000.000';
      case '4':
        return 'Más de 15.000.000';
      default:
        return '-';
    }
  };

  const actualizarDatosPersonaByEmpresa = async ({ cedula, persona }) => {
    let personaActualizada = null;
    // Validar con Servicio de la SET
    const razonSocial = await onBlurRucSet(cedula || persona?.cedula);
    if (persona) {
      personaActualizada = persona;
      personaActualizada = {
        ...personaActualizada,
        lugar_nacimiento: persona.lugarNacimiento,
        nacionalidad: fields.nacionalidad,
        estado_civil: fields.estadoCivil
      };
    } else {
      const personaEncontrada = await getDatosPersonaByEmpresa(
        `+595${formatCelular(form.getFieldValue('celular'))}`,
        cedula,
        empresa.id
      );
      personaActualizada = personaEncontrada;
      if (personaActualizada?.tercero) {
        personaActualizada.tercero.celular =
          (personaActualizada.tercero.celular &&
            parseCelular(personaActualizada.tercero.celular)) ||
          '';
      }
    }
    if (personaActualizada) {
      personaActualizada.celular = personaActualizada?.celular || '';
      const personaTransformada = transformarPropiedades(personaActualizada);
      const infoFactura = {
        nombres: personaTransformada.tercero.nombres,
        ruc: personaTransformada.tercero.ruc
      };
      delete personaTransformada.tercero.nombres;
      delete personaTransformada.tercero.ruc;

      if (esJuridica) {
        personaTransformada.tercero = {
          nombres: fields.tercero?.nombres,
          ruc: fields.tercero?.ruc,
          correo: fields.tercero?.correo,
          celular: fields.tercero?.celular,
          domicilio: fields.tercero?.domicilio
        };
      }

      setFields((fieldsParam) => {
        return {
          ...fieldsParam,
          ...personaTransformada,
          tercero: {
            ...personaTransformada.tercero, // Mantener los datos existentes en "tercero"
            ...(infoFactura &&
              !razonSocial && {
                nombres: infoFactura.nombres,
                ruc: infoFactura.ruc
              })
          }
        };
      });
      if (current === 2) {
        form.setFieldsValue({
          ...personaTransformada,
          tercero: {
            ...personaTransformada.tercero, // Mantener los datos existentes en "tercero"
            ...(infoFactura &&
              !razonSocial && {
                nombres: infoFactura.nombres,
                ruc: infoFactura.ruc
              })
          }
        });
      }
      if (personaTransformada.departamento) {
        await getDistritos({ departamento: personaTransformada.departamento });
        await getDistritos({
          departamentoTercero: personaTransformada.departamento
        });
      }
    }
  };

  const getSelectedPlan = () => {
    return cotizaciones
      .find((item) => item.id === selectedCotizacion)
      ?.planes.filter(
        ({ id_plan, id_moneda }) =>
          ((id_plan && selectedPlanTipo === 'estandar') ||
            (!id_plan && selectedPlanTipo === 'especifico')) &&
          id_moneda === selectedMonedaPlan.id
      )[selectedPlan];
  };

  const verificarCombustible = (id) => {
    const combustibleReconocido = reconocerCombustible(id, submodelos);
    if (combustibleReconocido) {
      form.setFieldsValue({ combustible: combustibleReconocido });
    } else {
      form.setFieldsValue({ combustible: undefined });
    }
  };

  const getSelectedCotizacion = () =>
    cotizaciones?.find((c) => c.id === selectedCotizacion);

  const solicitar = async (type) => {
    setPrincipalLoading(true);
    const cotizacion = getSelectedCotizacion();
    const { id: plan } = getSelectedPlan();
    const cotizacionNew = {
      ...cotizacion,
      endoso: fields.endoso,
      persona: {
        ...cotizacion.persona,
        id: fields.id ? fields.id : cotizacion.persona.id,
        cedula: fields.cedula,
        nombres: fields.nombres,
        celular: `${fields.prefix}${formatCelular(fields.celular)}`,
        correo: fields.correo,
        domicilio: fields.domicilio,
        id_departamento: fields.departamento,
        id_distrito: fields.distrito,
        nacionalidad: fields.nacionalidad,
        sexo: fields.sexo,
        estado_civil: fields.estadoCivil,
        lugar_nacimiento: fields.lugarNacimiento,
        fecha_nacimiento: fields.fechaNacimiento
          ? fields.fechaNacimiento.format('DD/MM/YYYY')
          : '',
        ruc: fields.ruc,
        profesion: fields.profesion,
        ingresos: getIngreso(fields.ingresos),
        proveedor_estado: fields.proveedorEstado ? 'Sí' : 'No',
        expuesta_politicamente: fields.politicamenteExpuesto ? 'Sí' : 'No',
        vinculo: fields.vinculo,
        entidad: fields.entidad,
        periodo: fields.periodo,
        tipo_empleado: fields.trabajo,
        institucion_publica: fields.institucion,
        institucion_cargo: fields.cargo,
        institucion_anhoingreso: fields.anioIngreso,
        empleador_ruc: fields.rucEmpleador || 'A Confirmar',
        empleador_empresa: fields.empresaEmpleador,
        empleador_telefono: fields.telefonoEmpleador || 'A Confirmar',
        empleador_celular: fields.celularEmpleador
          ? `${fields.prefix}${formatCelular(fields.celularEmpleador)}`
          : 'A Confirmar',
        empleador_direccion: fields.direccionEmpleador,
        juridica: esJuridica,
        latitud: coordenadasAsegurado?.lat,
        longitud: coordenadasAsegurado?.lng,
        personaBCP: fields.personaBCP,
        datos_externos: {
          ...datosExternosPersona,
          imagen: {
            ...datosExternosPersona.imagen,
            ...datosExternosPersonaImagenCID
          }
        }
      },
      vehiculo: {
        ...cotizacion.vehiculo,
        id_submodelo: fields.submodelo,
        id_aniosubmodelo: submodelos.find(
          (item) => item.id === fields.submodelo
        ).anios[0].id,
        chassis: fields.chassis,
        chapa: fields.chapa,
        color:
          fields.color === 'OTRO'
            ? fields.otroColor.toUpperCase()
            : fields.color,
        tipo_uso: fields.tipoUso,
        vehiculo_bcp: vehiculoBCP,
        tipo: fields.tipo,
        pais_origen: fields.paisOrigen,
        combustible: fields.combustible,
        tipo_chapa: fields.tipoChapa,
        anio_inscripcion: fields.anioInscripcion,
        formato_chapa: fields.formatoChapa,
        id_departamento: fields.departamentoZonaCirculacion,
        id_distrito: fields.distritoZonaCirculacion,
        ocupantes: fields.ocupantes,
        datos_externos: datosExternosVehiculoCVA
      }
    };

    const tercero = form.getFieldValue('tercero');

    const vigenciaPagosForm = vigenciaPagosContext;
    const modalidadPago = vigenciaPagosForm.pagos?.frecuencia?.id;

    const filesToSend = [];
    if (cedula1) {
      filesToSend.push(cedula1);
    }
    if (cedula2) {
      filesToSend.push(cedula2);
    }
    if (tieneCV && cedulaVerde1) {
      filesToSend.push(cedulaVerde1);
    }
    if (tieneCV && cedulaVerde2) {
      filesToSend.push(cedulaVerde2);
    }
    if (tieneHabilitacion && habilitacion1) {
      filesToSend.push(habilitacion1);
    }
    if (tieneHabilitacion && habilitacion2) {
      filesToSend.push(habilitacion2);
    }
    if (!tieneCV && certificadoVenta) {
      filesToSend.push(certificadoVenta);
    }
    if (!tieneCV && chapaProvisoria) {
      filesToSend.push(chapaProvisoria);
    }
    if (!tieneCV && certificadoNacionalizacion) {
      filesToSend.push(certificadoNacionalizacion);
    }
    const solicitud = {
      formaPago: fields.formaPago,
      idMetodoPago: fields.metodoPago,
      // idModalidadPago: fields.formaPago === 'CONTADO' ? 4 : 2,
      idModalidadPago: modalidadPago,
      idVigenciaPago: 4,
      numeroTarjeta: '',
      titularTarjeta: '',
      vencimientoTarjeta: '',
      marcaTarjeta: '',
      numeroCuenta: '',
      cotizacion: cotizacionNew,
      plan,
      files: filesToSend,
      tercero: {
        ...tercero,
        celular: tercero.celular
          ? `${fields.prefix}${formatCelular(tercero.celular)}`
          : null,
        telefono: fields.tercero.telefono
      },
      empresaJuridica: esJuridica
        ? {
            ...fields.empresaJuridica,
            id_persona: cotizacionNew.persona?.id,
            rucJuridicaBCP
          }
        : undefined,
      vigencia: {
        fechaInicioVigencia: vigenciaPagosForm.desde,
        fechaFinVigencia: vigenciaPagosForm.hasta,
        cantidadDias: vigenciaPagosForm.cantidad_dias
      },
      numeroCuotas: vigenciaPagosForm?.pagos?.cantidad_pagos,
      pagos: {
        list: calendarioPagosContext,
        numeroCuotas: vigenciaPagosForm?.pagos?.cantidad_pagos
      },
      tiene_impresion: impresion
    };
    try {
      await solicitarRequest(solicitud, empresa, type, undefined);
      setPrincipalLoading(false);
      setIsDirty(false);
      setSolicitado(true);
    } catch (error) {
      setPrincipalLoading(false);
      errorHandler(error, 'Error al enviar la solicitud');
      setIsDirty(true);
    }
  };

  const procesarCedulaVerdeDetras = (fileData) => {
    setVehiculoBCP(fileData.tipoDataVehiculoBCP);
    handleFormChange(fileData.chassis, 'chassis');
    datosImg.chassis = fileData.chassisimg;
    handleFormChange(fileData.chapa, 'chapa');
    datosImg.chapa = fileData.chapaimg;
    handleFormChange(fileData.anio, 'anioFabricacion');
    datosImg.anio = fileData.anioimg;
    datosImg.modelo = fileData.modeloimg;
    datosImg.marca = fileData.marca;
    datosImg.color = fileData.color;
    if (colores.some((item) => item.descripcion === fileData.color)) {
      handleFormChange(
        colores.find((item) => item.descripcion === fileData.color).descripcion,
        'color'
      );
    } else {
      handleFormChange('OTRO', 'color');
      handleFormChange(fileData.color, 'otroColor');
    }
    if (fileData.tipoDataVehiculoBCP) {
      founddatosBCP.chapa = fileData.chapa;
      founddatosBCP.chassis = fileData.chassis;
      founddatosBCP.anio = fileData.anioInscripcion;
      founddatosBCP.modelo = fileData.modeloBCP;
      founddatosBCP.marca = fileData.marcaBCP;
      founddatosBCP.uso = fileData.usoBCP;
      founddatosBCP.color = fileData.colorBCP;
      const newdatos = { ...datosBCP, ...founddatosBCP };
      setDatosBCP(newdatos);
    }

    // Datos de Vehiculo BCP
    handleFormChange(fileData.tipo, 'tipo');
    handleFormChange(fileData.paisOrigen, 'paisOrigen');
    handleFormChange(fileData.tipoChapa || 'DEFINITIVO', 'tipoChapa');
    handleFormChange(fileData.anioInscripcion, 'anioInscripcion');
    handleFormChange(fileData.formatoChapa, 'formatoChapa');

    const newdatos = { ...datosOriginales, ...datosImg };
    setDatosOriginales(newdatos);

    setDatosExternosVehiculoCVA({
      ...datosExternosVehiculoCVA,
      imagen: { ...datosImg, marca: fileData.marcaimg },
      bcp: founddatosBCP
    });

    setCedulaVerdeDorsalValidacion({
      ...fileData
    });

    if (fields.chapa) {
      // los valores de initialValues "fields" se establecen una sola vez, cuando el formulario se inicializa.
      // Cuando la chapa ya existe y fue renderizado los valores del formulario, se necesita modificar el estado del formulario manualmente para observar los cambios.
      const { chapa, chassis, color } = fileData;

      form.setFieldValue('chapa', chapa);
      form.setFieldValue('chassis', chassis);

      const foundColor = colores.find((item) => item.descripcion === color);

      if (foundColor) {
        form.setFieldValue('color', foundColor.descripcion);
      } else {
        form.setFieldValue('color', 'OTRO');
        form.setFieldValue('otroColor', color);
      }
    }
  };

  const uploadFile = async (file, type, setter, loading, idCotizacion) => {
    try {
      loading(true);
      const reCaptchaToken = await executeRecaptcha('file/upload');
      const converted = await heicAndheifConvert(file.file);
      const compressedFile = await myImageCompression(
        converted,
        compressionOptions
      );

      const formData = new FormData();
      const { aseguradora } = cotizaciones.find(
        (item) => item.id === selectedCotizacion
      ).aseguradoraEmpresaProducto.aseguradoraEmpresa;
      formData.append('cedula', compressedFile);
      formData.append('reCaptchaToken', reCaptchaToken);
      formData.append('token', token);
      formData.append('empresaId', empresa.id);
      formData.append('cotizacionId', selectedCotizacion);
      formData.append('aseguradoraId', aseguradora.id);

      let fileData;
      if (type !== 'CVA' && type !== 'CVD') {
        const response = await instanceRef.instance.post(
          `file/upload?tipo=${type}`,
          formData,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );
        fileData = response.data.data;
      }

      switch (type) {
        case 'CIA':
          validateCedulaIdentidad(fileData, 'CIA').then((isValid) => {
            if (!isEmpty(isValid)) {
              errorHandler(null, isValid);
              loading(false);
              setCedula1('');
            } else {
              const fechaStr = fileData.fechaNacimiento;
              const fechaMoment = moment(fechaStr, 'DD/MM/YYYY');
              const { persona } = fileData;
              datosImg.fechaNacimiento = fechaStr;
              datosImg.nombres = fileData.nombresimg;
              datosImg.cedula = fileData.cedula;
              datosImg.score = fileData.scoreNombres;
              const tercero = {
                nombres: fileData.razonSocial || fileData.nombres,
                cedula: fileData.cedula,
                ruc: fileData.ruc,
                celular: fields.celular,
                domicilio: fileData.persona ? fileData.persona.domicilio : '',
                correo: fileData.persona ? fileData.persona.correo : '',
                id_departamento: null,
                id_distrito: null
              };
              handleFormChange(fileData.nombres, 'nombres');
              handleFormChange(fileData.cedula, 'cedula');
              handleFormChange(fileData.ruc, 'ruc');
              handleFormChange(fileData.sexo, 'sexo');
              handleFormChange(fileData.lugarNacimiento, 'lugarNacimiento');
              handleFormChange(
                fields.celular && parseCelular(fields.celular),
                'celular'
              );
              if (fechaMoment.isValid()) {
                handleFormChange(fechaMoment, 'fechaNacimiento');
              }
              if (fileData.tipoDataBCP) {
                founddatosBCP.nombres = fileData.nombres;
                founddatosBCP.cedula = fileData.cedula;
                founddatosBCP.fechaNacimiento = fechaStr;
                founddatosBCP.datosCoincideBCP = fileData.datosCoincideBCP;
                const newdatos = { ...datosBCP, ...founddatosBCP };
                setDatosBCP(newdatos);
              }
              handleFormChange(fileData.tipoDataBCP, 'personaBCP');
              handleFormChange(tercero, 'tercero');
              actualizarDatosPersonaByEmpresa({
                persona: {
                  ...persona,
                  ...fileData,
                  fechaNacimiento: fechaMoment.isValid() ? fechaMoment : null,
                  celular: fields.celular,
                  tercero,
                  correo: fields?.correo || persona?.correo || ''
                }
              });

              setDatosContactoFromCIA({
                nombres: fileData.nombresimg,
                cedula: fileData.cedula
              });

              getBase64(compressedFile, (imageUrl) => {
                setter({
                  imagen: imageUrl,
                  extension: compressedFile.type.split('/')[1],
                  nombre: `${type}.${compressedFile.type.split('/')[1]}`
                });
                loading(false);
              });
              const newdatos = {
                ...datosOriginales,
                ...datosImg,
                cotizacion: {
                  departamentoId: fileData.cotizacion.departamentoId
                    ? fileData.cotizacion.departamentoId
                    : null,
                  distritoId: fileData.cotizacion.distritoId
                    ? fileData.cotizacion.distritoId
                    : null,
                  domicilio: fileData.cotizacion.domicilio
                    ? fileData.cotizacion.domicilio
                    : null
                }
              };
              setDatosOriginales(newdatos);
              setDatosExternosPersona({
                ...datosExternosPersona,
                imagen: {
                  ...datosExternosPersona.imagen,
                  cedula: fileData.cedula,
                  nombres: fileData.nombresimg,
                  fechaNacimiento: fileData.fechasimg[0],
                  sexo: fileData.sexo
                },
                bcp: {
                  cedula: fileData.tipoDataBCP && fileData.cedula,
                  nombres: fileData.nombresBcp,
                  fechaNacimiento: fileData.fechasBcp,
                  nombre: fileData.nombreBcp,
                  apellido: fileData.apellidoBcp
                },
                set: {
                  nombres: fileData.razonSocial,
                  ruc: fileData.ruc
                },
                sistemaCore: {
                  ...fileData.clienteExterno,
                  cedula: fileData.cedula,
                  nombres:
                    fileData.clienteExterno && fileData.clienteExterno.nombre,
                  fechaNacimiento:
                    fileData.clienteExterno &&
                    fileData.clienteExterno.fechaNacimiento,
                  sexo: fileData.clienteExterno && fileData.clienteExterno.sexo,
                  estadoCivil:
                    fileData.clienteExterno &&
                    fileData.clienteExterno.estado_civil
                }
              });

              formCedula.setFieldsValue({
                numeroCedulaModificada: fileData.cedula
              });
              setNumeroCedula(fileData.cedula);
            }
          });
          break;
        case 'CID':
          validateCedulaIdentidad(fileData, 'CID').then((isValid) => {
            if (!isEmpty(isValid)) {
              errorHandler(null, isValid);
              loading(false);
              setCedula2('');
            } else {
              // Los datos de fileData son de la imagen de la cedula, los datos fileData.persona son datos de la BD
              const nacionalidad = fileData.persona
                ? fileData.persona.nacionalidad
                : fileData.nacionalidad;
              if (nacionalidad === NACIONALIDADES[0].descripcion) {
                handleFormChange(NACIONALIDADES[0].descripcion, 'nacionalidad');
              } else {
                handleFormChange(NACIONALIDADES[1].descripcion, 'nacionalidad');
              }

              let estadoCivil = fileData.persona
                ? fileData.persona.estado_civil
                : fileData.estadoCivil;
              const estado = ESTADOS.filter(({ descripcion }) => {
                return descripcion === estadoCivil;
              });
              estadoCivil = estado[0] ? estado[0].descripcion : undefined;
              handleFormChange(estadoCivil, 'estadoCivil');

              const nombres = fileData.nombres ? fileData.nombres : null;
              const cedula = fileData.nroDocumento
                ? fileData.nroDocumento
                : null;

              setDatosContactoFromCID({
                nombres,
                cedula
              });

              setDatosExternosPersonaImagenCID({
                nacionalidad: fileData.nacionalidad,
                estadoCivil: fileData.estadoCivil
              });

              getBase64(compressedFile, (imageUrl) => {
                setter({
                  imagen: imageUrl,
                  extension: compressedFile.type.split('/')[1],
                  nombre: `${type}.${compressedFile.type.split('/')[1]}`
                });
                loading(false);
              });
            }
          });
          break;
        // case 'CVD': {
        //   const isValid = validateCedulaVerde(fileData, 'CVD');
        //   if (!isEmpty(isValid)) {
        //     errorHandler(null, isValid);
        //     loading(false);
        //     setCedulaVerde2('');
        //   } else if (
        //     cotizaciones?.[0]?.vehiculo.marca.descripcion !==
        //     fileData.marca.descripcion
        //   ) {
        //     errorHandler(
        //       null,
        //       'Los datos de la cédula verde no coinciden con los datos ingresados en el formulario'
        //     );
        //     loading(false);
        //   } else {
        //     setVehiculoBCP(fileData.tipoDataVehiculoBCP);
        //     handleFormChange(fileData.chassis, 'chassis');
        //     datosImg.chassis = fileData.chassisimg;
        //     handleFormChange(fileData.chapa, 'chapa');
        //     datosImg.chapa = fileData.chapa;
        //     handleFormChange(fileData.anio, 'anioFabricacion');
        //     datosImg.anio = fileData.anioimg;
        //     datosImg.modelo = fileData.modeloimg;
        //     datosImg.marca = fileData.marca;
        //     datosImg.color = fileData.color;
        //     if (colores.some((item) => item.descripcion === fileData.color)) {
        //       handleFormChange(
        //         colores.find((item) => item.descripcion === fileData.color)
        //           .descripcion,
        //         'color'
        //       );
        //     } else {
        //       handleFormChange('OTRO', 'color');
        //       handleFormChange(fileData.color, 'otroColor');
        //     }
        //     if (fileData.tipoDataVehiculoBCP) {
        //       founddatosBCP.chapa = fileData.chapa;
        //       founddatosBCP.chassis = fileData.chassis;
        //       founddatosBCP.anio = fileData.anioInscripcion;
        //       founddatosBCP.modelo = fileData.modeloBCP;
        //       founddatosBCP.marca = fileData.marcaBCP;
        //       founddatosBCP.uso = fileData.usoBCP;
        //       founddatosBCP.color = fileData.colorBCP;
        //       const newdatos = { ...datosBCP, ...founddatosBCP };
        //       setDatosBCP(newdatos);
        //     }

        //     // Datos de Vehiculo BCP
        //     handleFormChange(fileData.tipo, 'tipo');
        //     handleFormChange(fileData.paisOrigen, 'paisOrigen');
        //     handleFormChange(fileData.tipoChapa || 'DEFINITIVO', 'tipoChapa');
        //     handleFormChange(fileData.anioInscripcion, 'anioInscripcion');
        //     handleFormChange(fileData.formatoChapa, 'formatoChapa');

        //     const newdatos = { ...datosOriginales, ...datosImg };
        //     setDatosOriginales(newdatos);

        //     setDatosExternosVehiculoCVA({
        //       ...datosExternosVehiculoCVA,
        //       imagen: { ...datosImg, marca: fileData.marcaimg },
        //       bcp: founddatosBCP
        //     });

        //     getBase64(compressedFile, (imageUrl) => {
        //       setter({
        //         imagen: imageUrl,
        //         extension: compressedFile.type.split('/')[1],
        //         nombre: `${type}.${compressedFile.type.split('/')[1]}`
        //       });
        //       loading(false);
        //     });
        //   }

        //   break;
        // }
        // case 'CVA': {
        //   const isValid = validateCedulaVerde(fileData, 'CVA');
        //   if (!isEmpty(isValid)) {
        //     errorHandler(null, isValid);
        //     loading(false);
        //     setCedulaVerde1('');
        //   } else {
        //     // Depto y Distrito: 1-Cotizado por Ejecutivo, 2-Persona BD, 3-Datos de la Cedula Verde
        //     const departamentoCVAId = fileData.departamentoSelected?.id || null;
        //     const departamentoId =
        //       fields.departamento || departamentoCVAId || null;
        //     handleFormChange(departamentoId, 'departamento');

        //     const distritoCVAId = fileData.distritoSelected?.id || null;
        //     const distritoId = fields.distrito || distritoCVAId || null;
        //     handleFormChange(distritoId, 'distrito');

        //     const domicilio = fields.domicilio || fileData.domicilio;
        //     handleFormChange(domicilio, 'domicilio');

        //     const terceroDomicilio = !esJuridica ? domicilio : '';
        //     const tercero = {
        //       ...fields.tercero,
        //       domicilio: terceroDomicilio,
        //       id_departamento: departamentoId,
        //       id_distrito: distritoId
        //     };
        //     handleFormChange(tercero, 'tercero');

        //     getDistritos({ departamento: departamentoId });
        //     getDistritos({ departamentoTercero: departamentoId });
        //     getBase64(compressedFile, (imageUrl) => {
        //       setter({
        //         imagen: imageUrl,
        //         extension: compressedFile.type.split('/')[1],
        //         nombre: `${type}.${compressedFile.type.split('/')[1]}`
        //       });
        //       loading(false);
        //     });
        //   }
        //   break;
        // }
        case 'HAD':
          getBase64(compressedFile, (imageUrl) => {
            setter({
              imagen: imageUrl,
              extension: compressedFile.type.split('/')[1],
              nombre: `${type}.${compressedFile.type.split('/')[1]}`
            });
            loading(false);
          });
          break;
        case 'HAA':
          getBase64(compressedFile, (imageUrl) => {
            setter({
              imagen: imageUrl,
              extension: compressedFile.type.split('/')[1],
              nombre: `${type}.${compressedFile.type.split('/')[1]}`
            });
            loading(false);
          });
          break;
        case 'CERV':
          getBase64(compressedFile, (imageUrl) => {
            setter({
              imagen: imageUrl,
              extension: compressedFile.type.split('/')[1],
              nombre: `${type}.${compressedFile.type.split('/')[1]}`
            });
            loading(false);
          });
          break;
        case 'CP': {
          const isValid = validateChapaProvisoria(fileData);
          if (!isEmpty(isValid)) {
            errorHandler(null, isValid);
            loading(false);
            setChapaProvisoria('');
          } else if (
            cotizaciones?.[0]?.vehiculo.marca.descripcion !==
            fileData.marca.descripcion
          ) {
            errorHandler(
              null,
              'Los datos de la Chapa Provisoria no coinciden con los datos ingresados en el formulario'
            );
            loading(false);
          } else {
            setVehiculoBCP(fileData.tipoDataVehiculoBCP);
            handleFormChange(fileData.chassis, 'chassis');
            datosImg.chassis = fileData.chassisimg;
            handleFormChange(fileData.chapa, 'chapa');
            datosImg.chapa = fileData.chapa;
            handleFormChange(fileData.anio, 'anioFabricacion');
            datosImg.anio = fileData.anioimg;
            datosImg.modelo = fileData.modeloimg;
            datosImg.marca = fileData.marca;
            datosImg.color = fileData.color;
            if (colores.some((item) => item.descripcion === fileData.color)) {
              handleFormChange(
                colores.find((item) => item.descripcion === fileData.color)
                  .descripcion,
                'color'
              );
            } else {
              handleFormChange('OTRO', 'color');
              handleFormChange(fileData.color, 'otroColor');
            }
            if (fileData.tipoDataVehiculoBCP) {
              founddatosBCP.chapa = fileData.chapa;
              founddatosBCP.chassis = fileData.chassis;
              founddatosBCP.anio = fileData.anioInscripcion;
              founddatosBCP.modelo = fileData.modeloBCP;
              founddatosBCP.marca = fileData.marcaBCP;
              founddatosBCP.uso = fileData.usoBCP;
              founddatosBCP.color = fileData.colorBCP;
              const newdatos = { ...datosBCP, ...founddatosBCP };
              setDatosBCP(newdatos);
            }

            // Datos de Vehiculo BCP
            handleFormChange(fileData.tipo, 'tipo');
            handleFormChange(fileData.paisOrigen, 'paisOrigen');
            handleFormChange(fileData.tipoChapa || 'PROVISORIO', 'tipoChapa');
            handleFormChange(fileData.anioInscripcion, 'anioInscripcion');
            handleFormChange(fileData.formatoChapa, 'formatoChapa');

            const newdatos = { ...datosOriginales, ...datosImg };
            setDatosOriginales(newdatos);

            setDatosExternosVehiculoCVA({
              ...datosExternosVehiculoCVA,
              imagen: { ...datosImg, marca: fileData.marcaimg },
              bcp: founddatosBCP
            });

            getBase64(compressedFile, (imageUrl) => {
              setter({
                imagen: imageUrl,
                extension: compressedFile.type.split('/')[1],
                nombre: `${type}.${compressedFile.type.split('/')[1]}`
              });
              loading(false);
            });
          }

          break;
        }
        case 'CERN':
          getBase64(compressedFile, (imageUrl) => {
            setter({
              imagen: imageUrl,
              extension: compressedFile.type.split('/')[1],
              nombre: `${type}.${compressedFile.type.split('/')[1]}`
            });
            loading(false);
          });
          break;
        default:
          break;
      }
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      loading(false);
    }
    try {
      let responseCedulaVerde;
      setIdCotizacionActual(idCotizacion);
      if (type === 'CVA' || type === 'CVD') {
        loading(true);
        const reCaptchaToken = await executeRecaptcha('file/upload');
        const converted = await heicAndheifConvert(file.file);
        const compressedFile = await myImageCompression(
          converted,
          compressionOptions
        );

        const formData = new FormData();
        formData.append('cedula', compressedFile);
        formData.append('reCaptchaToken', reCaptchaToken);
        formData.append('token', token);
        formData.append('empresaId', empresa.id);
        formData.append('cotizacionId', selectedCotizacion);
        responseCedulaVerde = await instanceRef.instance.post(
          `file//uploadCedulaVerde?tipo=${type}&idcotizacion=${idCotizacion}`,
          formData,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );
        const datosValidacion = responseCedulaVerde?.data?.data;
        if (responseCedulaVerde.data) {
          const fileData = datosValidacion;
          if (type === 'CVA') {
            const isValid = validateCedulaVerde(fileData, 'CVA');
            if (!isEmpty(isValid)) {
              errorHandler(null, isValid);
              loading(false);
              setCedulaVerde1('');
            } else {
              // Depto y Distrito: 1-Cotizado por Ejecutivo, 2-Persona BD, 3-Datos de la Cedula Verde
              const departamentoCVAId =
                fileData.departamentoSelected?.id || null;
              const departamentoId =
                fields.departamento || departamentoCVAId || null;
              handleFormChange(departamentoId, 'departamento');

              const distritoCVAId = fileData.distritoSelected?.id || null;
              const distritoId = fields.distrito || distritoCVAId || null;
              handleFormChange(distritoId, 'distrito');

              const domicilio = fields.domicilio || fileData.domicilio;
              handleFormChange(domicilio, 'domicilio');

              const terceroDomicilio = !esJuridica ? domicilio : '';
              const tercero = {
                ...fields.tercero,
                domicilio: terceroDomicilio,
                id_departamento: departamentoId,
                id_distrito: distritoId
              };
              handleFormChange(tercero, 'tercero');

              getDistritos({ departamento: departamentoId });
              getDistritos({ departamentoTercero: departamentoId });
              getBase64(compressedFile, (imageUrl) => {
                setter({
                  imagen: imageUrl,
                  extension: compressedFile.type.split('/')[1],
                  nombre: `${type}.${compressedFile.type.split('/')[1]}`
                });
                loading(false);
              });

              setCedulaVerdeFrontalValidacion({
                ...datosValidacion
              });
            }
          }
          if (type === 'CVD') {
            procesarCedulaVerdeDetras(fileData);
            getBase64(compressedFile, (imageUrl) => {
              setter({
                imagen: imageUrl,
                extension: compressedFile.type.split('/')[1],
                nombre: `${type}.${compressedFile.type.split('/')[1]}`
              });
              loading(false);
            });
          }
        }
        loading(false);
      }
    } catch (error) {
      errorHandler(error, error.message);
      loading(false);
    }
  };

  const uploadChapaEditada = async (idCotizacion, chapaEditadaUsuario) => {
    if (cedulaVerdeDorsalValidacion.chapa !== textValueModalChapa) {
      try {
        const reCaptchaToken = await executeRecaptcha('file/upload');
        const formData = new FormData();
        formData.append('reCaptchaToken', reCaptchaToken);
        formData.append('token', token);
        formData.append('empresaId', empresa.id);
        formData.append('cotizacionId', selectedCotizacion);
        const responseChapaEditada = await instanceRef.instance.post(
          `file//uploadCedulaVerde?tipo=CVD&idcotizacion=${idCotizacion}&chapaInputManualUsuario=${chapaEditadaUsuario}`,
          formData,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );
        const datosValidacion = responseChapaEditada?.data?.data;
        return datosValidacion;
        // if (responseChapaEditada.data) {
        //   setCedulaVerdeDorsalValidacion({
        //     ...datosValidacion
        //   });
        // }
      } catch (error) {
        // eslint-disable-next-line no-empty
        return null;
      }
    }
    return null;
  };

  const onClickContinuarChapaEditada = async () => {
    const datosValidacion = await uploadChapaEditada(
      idCotizacionActual,
      textValueModalChapa
    );
    if (datosValidacion) {
      const fileData = datosValidacion;
      procesarCedulaVerdeDetras(fileData);
    }
    setModalEstaEsTuChapa(false);
    setCurrent(current + 1);
    scrollTop();
  };

  const onClickContinuarCedulaEditada = async () => {
    let datosObtenidos = null;

    setConfirmarCedulaLoading(true);
    setMostrarConfirmarCedula(false);
    const numeroCedulaUsuario = formCedula.getFieldValue(
      'numeroCedulaModificada'
    );
    setNumeroCedulaModificada(numeroCedulaUsuario);

    // Si hay inconsistencia de nombres pero el usuario no modifica, se prioriza BCP o vacío.
    if (numeroCedulaUsuario === numeroCedula && datosExternosPersona.bcp) {
      const {
        nombres = '',
        nombre = '',
        apellido = ''
      } = datosExternosPersona.bcp;
      handleFormChange(nombres, 'nombres');
      handleFormChange(nombre, 'nombre');
      handleFormChange(apellido, 'apellido');
    }

    // Si el usuario ingresa otro número de cédula, obtener datos.
    if (numeroCedulaUsuario !== numeroCedula) {
      handleFormChange('cedula', numeroCedulaUsuario);
      datosObtenidos = await getCliente(numeroCedulaUsuario);

      if (datosObtenidos?.clienteExterno) {
        const { nombres = '', nombre = '', apellido = '' } =
          datosExternosPersona.bcp || {};

        handleFormChange(nombres, 'nombres');
        handleFormChange(nombre, 'nombre');
        handleFormChange(apellido, 'apellido');

        setDatosExternosPersona((prev) => ({
          ...prev,
          bcp: {
            cedula: numeroCedulaUsuario,
            nombres,
            fechaNacimiento: datosObtenidos.fechasBcp || '',
            nombre,
            apellido
          }
        }));
      } else {
        ['nombres', 'nombre', 'apellido'].forEach((field) =>
          handleFormChange('', field)
        );
      }
    }
    setConfirmarCedulaLoading(false);
    // Espera a que `datosObtenidos` se obtenga antes de avanzar al siguiente paso
    if (numeroCedulaUsuario === numeroCedula || datosObtenidos) {
      setSubpasoDocumentos(1);
    }

    scrollTop();
  };

  const validateStep = (step, subpaso) => {
    switch (step) {
      case 0: {
        if (selectedPlan === null || selectedPlan === undefined) {
          message.warning('Debe seleccionar un plan');
          return false;
        }
        const { contado, fraccionado12 } = getSelectedPlan();
        const cantidadPagosSeleccionado =
          vigenciaPagosContext?.pagos?.cantidad_pagos;
        if (
          (cantidadPagosSeleccionado === 1 && contado === 0) ||
          (cantidadPagosSeleccionado > 1 && fraccionado12 === 0)
        ) {
          message.warning(
            `El plan no se encuentra disponible en la forma de pago seleccionada (${
              cantidadPagosSeleccionado === 1
                ? 'contado'
                : `${cantidadPagosSeleccionado} cuotas`
            })`
          );
          return false;
        }
        return true;
      }
      case 1:
        if (subpaso === 0) {
          if (!esJuridica && !soloNumCedula && (!cedula1 || !cedula2)) {
            message.warning('Debe cargar su cédula de identidad (ambos lados)');
            return false;
          }
          if (!esJuridica && !coincideCI && !soloNumCedula) {
            message.warning(
              'Debe coincidir su cédula de identidad frente/dorso'
            );
            return false;
          }
          if (soloNumCedula) {
            cedulaManualForm.validateFields();
            if (
              !cedulaManualForm.getFieldValue('cedula') ||
              !cedulaManualForm.getFieldValue('cedula').match(/^[0-9]{5,8}$/)
            ) {
              return false;
            }
          }
        }
        if (subpaso === 1) {
          if (tieneCV && (!cedulaVerde1 || !cedulaVerde2)) {
            message.warning('Debe cargar la cédula verde (ambos lados)');
            return false;
          }

          if (
            !tieneCV &&
            (!certificadoVenta ||
              !chapaProvisoria ||
              !certificadoNacionalizacion)
          ) {
            message.warning(
              'Debe cargar el Certificado de Venta, la Chapa Provisoria y el Certificado de Nacionalización'
            );
            return false;
          }
        }

        return true;
      default:
        return false;
    }
  };

  const getDepartamentos = async () => {
    try {
      const response = await instanceRef.instance.get(`data/departamentos`);
      const orderedDepartamentos = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setDepartamentos(orderedDepartamentos);
      const values = form.getFieldsValue();
      const { departamento } = values;
      if (departamento) {
        await getDistritos({ departamento });
      }

      const departamentoTercero =
        values.tercero?.id_departamento || departamento;
      if (departamentoTercero) {
        await getDistritos({ departamentoTercero });
      }
      const departamentoZonaCirculacion =
        fields.departamentoZonaCirculacion ||
        cotizaciones[0].vehiculo?.id_departamento;
      if (departamentoZonaCirculacion) {
        await getDistritos({ departamentoZonaCirculacion });
      }
    } catch (error) {
      // error
    }
  };

  const getDistritos = async ({
    departamento,
    departamentoTercero,
    departamentoZonaCirculacion
  }) => {
    try {
      if (departamento || departamentoTercero || departamentoZonaCirculacion) {
        const search =
          departamento || departamentoTercero || departamentoZonaCirculacion;
        const response = await instanceRef.instance.get(
          `data/distritos?departamento=${search}`
        );
        const orderedDistritos = response.data.data.sort(function test(a, b) {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        });
        if (departamento) {
          setDistritos(orderedDistritos);
        } else if (departamentoTercero) {
          setDistritosTercero(orderedDistritos);
        } else if (departamentoZonaCirculacion) {
          setDistritosZonaCirculacion(orderedDistritos);
        }
      }
    } catch (error) {
      // error
    }
  };

  const getMarcas = async () => {
    try {
      const response = await instanceRef.instance.get(`data/marcas`);
      const orderedMarcas = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setMarcas(orderedMarcas);
    } catch (error) {
      // error
    }
  };

  const getModelos = async () => {
    try {
      const response = await instanceRef.instance.get(
        `data/modelos?marca=${fields.marca}`
      );
      const orderedModelos = response.data.data
        ? response.data.data.sort(function test(a, b) {
            if (a.descripcion < b.descripcion) {
              return -1;
            }
            if (a.descripcion > b.descripcion) {
              return 1;
            }
            return 0;
          })
        : [];
      setModelos(orderedModelos);
    } catch (error) {
      // error
    }
  };

  const getSubmodelos = async () => {
    try {
      const response = await instanceRef.instance.get(
        `data/submodelos?marca=${fields.marca}&modelo=${fields.modelo}&anio=${fields.anio}`
      );
      const orderedSubmodelos = response.data.data
        ? response.data.data.sort(function test(a, b) {
            if (a.descripcion < b.descripcion) {
              return -1;
            }
            if (a.descripcion > b.descripcion) {
              return 1;
            }
            return 0;
          })
        : [];
      setSubmodelos(orderedSubmodelos);
    } catch (error) {
      // error
    }
  };

  const getAnios = async () => {
    try {
      const response = await instanceRef.instance.get(
        `data/anios?marca=${fields.marca}&modelo=${fields.modelo}`
      );
      const anioCotizacionDescripcion = Number(fields.anio);
      /* const anioInscripcion =
        fields.anioInscripcion && Number(fields.anioInscripcion); */
      const anioFabricacion =
        fields.anioFabricacion && fields.anioFabricacion.codigo;

      const anioSugerido =
        response.data.data &&
        response.data.data.find((item) => {
          return Number(item.descripcion) === anioCotizacionDescripcion;
        });
      const filtrarAnios = response.data.data
        ? response.data.data.filter((item) => {
            if (anioFabricacion && anioSugerido.descripcion) {
              const sugeridoDesde =
                Number(anioFabricacion) < Number(anioSugerido.descripcion)
                  ? Number(anioFabricacion)
                  : Number(anioSugerido.descripcion);
              const sugeridoHasta =
                Number(anioFabricacion) > Number(anioSugerido.descripcion)
                  ? Number(anioFabricacion)
                  : Number(anioSugerido.descripcion);
              if (
                Number(item.descripcion) >= sugeridoDesde &&
                Number(item.descripcion) <= sugeridoHasta
              ) {
                return item;
              }
            } else {
              return item;
            }

            return null;
          })
        : [];

      const orderedAnios = filtrarAnios
        ? filtrarAnios.sort(function test(a, b) {
            if (parseInt(a.descripcion) < parseInt(b.descripcion)) {
              return 1;
            }
            if (parseInt(a.descripcion) > parseInt(b.descripcion)) {
              return -1;
            }
            return 0;
          })
        : [];
      setAnios(orderedAnios);
    } catch (error) {
      // error
    }
  };

  const handleInputChange = (field, { target }) => {
    changeData(field, target.value);
  };

  const onChangeDatePicket = (date, dateString) => {
    changeData('fecha nacimiento', dateString);
  };

  const onRucChange = async (ruc) => {
    const { aseguradora } = cotizaciones.filter(
      (c) => c.id === selectedCotizacion
    )[0].aseguradoraEmpresa;
    const datosbcp = await getDatosBCP(2, ruc, aseguradora);
    if (datosbcp && datosbcp.codigo === 0) {
      const { empresaJuridica } = form.getFieldsValue();
      form.setFieldsValue({
        empresaJuridica: {
          ...empresaJuridica,
          razon: datosbcp.nombre_apellido
        }
      });
      handleFormEmpresaJuridicaChange(datosbcp.nombre_apellido, 'razon');
      setRucJuridicaBCP(true);
    } else {
      // Se debe activar la bandera STAND BY
      // setDatosEncontradosEmpresaJuridica({});
    }
  };

  const debounceFormRucChange = debounce(async (value) => {
    onRucChange(value);
  }, 500);

  const debounceRucSet = debounce(async (value, esTercero) => {
    const razonSocial = await getDatosSetByRuc(value);
    const { tercero } = form.getFieldsValue();
    if (esTercero) {
      form.setFieldsValue({
        tercero: {
          ...tercero,
          ruc: value,
          nombres: razonSocial
        }
      });
      setFields((fieldsParam) => {
        return {
          ...fieldsParam,
          tercero: { ...fieldsParam.tercero, ruc: value, nombres: razonSocial }
        };
      });
    } else {
      form.setFieldsValue({ empresaEmpleador: razonSocial });
    }

    return razonSocial;
  }, 500);

  const onBlurRucSet = async (value) => {
    const { tercero } = form.getFieldsValue();
    try {
      const datos = await getDatosSetByRuc(value);

      if (datos) {
        form.setFieldsValue({
          tercero: {
            ...tercero,
            ruc: `${datos.ci}-${datos.dv}`,
            nombres: datos.razonSocial
          }
        });
        setFields((fieldsParam) => {
          return {
            ...fieldsParam,
            tercero: {
              ...fieldsParam.tercero,
              ruc: `${datos.ci}-${datos.dv}`,
              nombres: datos.razonSocial
            }
          };
        });
      }
      return datos?.razonSocial || '';
    } catch (error) {
      message.error('Error al validar CI / RUC!');
      form.setFieldsValue({
        tercero: {
          ...tercero,
          ruc: '',
          nombres: ''
        }
      });
      return {};
    }
  };

  const handleFormChange = (value, field) => {
    setFields((fieldsParams) => {
      return { ...fieldsParams, [field]: value };
    });
  };

  const handleFormTerceroChange = (value, field, field2) => {
    const { tercero } = form.getFieldsValue();
    let terceroNew;
    if (field2) {
      // tercero.grupoTelefono = { ...tercero.grupoTelefono, [field2]: value };
      const grupoTelefono = { ...tercero.grupoTelefono, [field2]: value };
      terceroNew = { ...tercero, grupoTelefono };
    } else {
      terceroNew = { ...tercero, [field]: value };
      form.setFieldsValue({
        tercero: terceroNew
      });
    }

    handleFormChange(terceroNew, 'tercero');
  };

  const handleFormEmpresaJuridicaChange = (value, field) => {
    setFields((fieldsParam) => {
      return {
        ...fieldsParam,
        empresaJuridica: { ...fieldsParam.empresaJuridica, [field]: value }
      };
    });
  };

  const debounceFormChange = debounce(async (value, field) => {
    handleFormChange(value, field);
    await actualizarDatosPersonaByEmpresa({
      cedula: value,
      empresaId: empresa.id
    });
  }, 500);

  const formChange = debounce(async (value, field) => {
    handleFormChange(value, field);
    await actualizarDatosPersonaByEmpresa({
      cedula: value,
      empresaId: empresa.id
    });
  }, 500);

  const geocalizarAsegurado = async () => {
    const departamento = form.getFieldValue('departamento');
    const distrito = form.getFieldValue('distrito');
    const domicilio = form.getFieldValue('domicilio') || '';

    const departamentosCopia = [...departamentos];
    const departamentoDesc = departamento
      ? departamentosCopia.find((item) => item.id === departamento)?.descripcion
      : '';

    const distritoDesc = distrito
      ? distritos.find((item) => item.id === distrito)?.descripcion
      : '';

    const direccionConcat = `${departamentoDesc}, ${distritoDesc}, ${domicilio}`;

    const coordenadasEncontrada = await getCoordenadasByDireccion(
      direccionConcat
    );
    setCoordenadasAsegurado(coordenadasEncontrada);
  };

  const verificarDigito = (ruc) => {
    const documentoSplit = ruc.split('-');
    const nroDocumento = documentoSplit[0];
    const digito = documentoSplit[1];
    if (digito) {
      const digitoCalculado = calcularDigitoVerificador(nroDocumento);
      if (Number(digito) === digitoCalculado) {
        return true;
      }
    }
    return false;
  };

  const onFinish = () => {
    setCurrent(current + 1);
    scrollTop();
  };

  const onFinishFailed = () => {
    message.warning('Completá todos los campos requeridos.');
  };

  const eventListener = (event) => {
    if (isDirty) {
      // Cancel the event as stated by the standard.
      event.preventDefault();
      // Chrome requires returnValue to be set.
      // eslint-disable-next-line no-param-reassign
      event.returnValue =
        'Es posible que los cambios que implementaste no se puedan guardar';
    }
  };

  const getDescripcionDistrito = () => {
    const distrito = distritosZonaCirculacion.find(
      (d) => d.id === `${cotizaciones?.[0]?.vehiculo?.id_distrito}`
    )?.descripcion;
    if (distrito) {
      return `${distrito}, `;
    }
    return '';
  };

  const onAnterior = () => {
    if (current === 1 && subpasoDocumentos === 1) {
      setSubpasoDocumentos(0);
    } else {
      setCurrent(current - 1);
    }
  };

  const onSiguiente = () => {
    if (
      current === 1 &&
      subpasoDocumentos === 1 &&
      (cedulaVerdeDorsalValidacion?.codigoStatusVerificacion === 1 ||
        cedulaVerdeFrontalValidacion?.codigoStatusVerificacion === 1)
    ) {
      setModalCedulaVerdeInvalida(true);
      return;
    }
    if (
      current === 1 &&
      subpasoDocumentos === 1 &&
      cedulaVerdeDorsalValidacion?.codigoStatusVerificacion === 2
    ) {
      setTextValueModalChapa(cedulaVerdeDorsalValidacion.chapa);
      setModalEstaEsTuChapa(true);
      return;
    }
    // Si no existen codigos de validaciones que requieran modales, continua directo al siguiente paso
    const valido = validateStep(current, subpasoDocumentos);
    if (current === 1 && subpasoDocumentos === 0 && valido) {
      if (!datosBCP.datosCoincideBCP && !numeroCedulaModificada) {
        setMostrarConfirmarCedula(true);
        return;
      }
      if (current === 1 && soloNumCedula) {
        getDatosCliente();
      } else {
        setSubpasoDocumentos(1);
      }
    } else if (valido) {
      setCurrent(current + 1);
      scrollTop();
    }
  };

  const baseURL = CONFIG.URL_BASE;

  const todasCotizacionesPendienteAutorizacion = !(
    cotizaciones && cotizaciones.length > 0
  )
    ? false
    : cotizaciones.every(
        (item) => item?.autorizacionFlujo[0]?.estado === 'PENDIENTE'
      );

  const handlePrintClick = (e) => {
    let url;
    switch (e.key) {
      case 'cotizacion':
        url = `${baseURL}/cotizacion/info-pdf?token=${token}&cantidad_pagos=${
          vigenciaPagosContext?.pagos?.cantidad_pagos
        }&cantidad_dias=${
          vigenciaPagosContext?.cantidad_dias
        }&desde=${vigenciaPagosContext?.desde.format()}&hasta=${vigenciaPagosContext?.hasta.format()}&tipo=cotizacion`;
        window.open(url, '_blank');
        break;
      case 'propuestas':
        url = `${baseURL}/cotizacion/info-pdf?token=${token}&cantidad_pagos=${
          vigenciaPagosContext?.pagos?.cantidad_pagos
        }&cantidad_dias=${
          vigenciaPagosContext?.cantidad_dias
        }&desde=${vigenciaPagosContext?.desde.format()}&hasta=${vigenciaPagosContext?.hasta.format()}&tipo=propuestas`;
        window.open(url, '_blank');
        break;
      default:
    }
  };
  const items = [
    {
      label: 'Cotización',
      key: 'cotizacion'
    },
    {
      label: 'Propuestas',
      key: 'propuestas'
    }
  ];

  const dropDownProps = {
    items,
    onClick: handlePrintClick
  };

  useEffect(() => {
    getMarcas();
    getDepartamentos();
    setCuestionario(productoCotizacion.cuestionario);
    const cuestionarioOptions = {};
    // eslint-disable-next-line guard-for-in
    for (const key in cuestionario) {
      cuestionarioOptions[key] = false;
    }
  }, []);

  useEffect(() => {
    if (cedula1 && cedula2) {
      validarCedulaIdentidad();
    }
  }, [cedula1, cedula2, validarCedulaIdentidad]);

  useEffect(() => {
    if (empresa && producto && token) {
      getVigenciaSugeridaAndConfig();
    }
  }, [empresa, getVigenciaSugeridaAndConfig, producto, token]);

  useEffect(() => {
    if (cotizaciones && cotizaciones.length > 0 && screens.md !== undefined) {
      const { persona } = cotizaciones[0];
      setProductoCotizacion(cotizaciones[0].producto);
      if (!fields.celular && !fields.nombres) {
        handleFormChange(persona.nombres, 'nombres');
        handleFormChange(parseCelular(persona.celular), 'celular');
      }

      if (!fields.correo) {
        handleFormChange(persona.correo, 'correo');
      }
      setSelectedCotizacion(undefined);
      setSelectedPlan(undefined);
      setSelectedMonedaPlan(undefined);
      setSelectedPlanTipo(undefined);
      setCurrent(0);
      setSubpasoDocumentos(0);
      const { vehiculo } = cotizaciones[0];
      const zeroCount = 6;
      const roundedNumber =
        Math.round(
          // eslint-disable-next-line no-restricted-properties
          parseInt(vehiculo.monto_asegurado) / Math.pow(10, zeroCount)
        ) * 1000000;

      handleFormChange(vehiculo.id_marca, 'marca');
      handleFormChange(vehiculo.id_modelo, 'modelo');
      handleFormChange(vehiculo.id_submodelo, 'submodelo');
      handleFormChange(vehiculo.aniosubmodelo.descripcion, 'anio');
      handleFormChange(vehiculo.combustible, 'combustible');
      handleFormChange(vehiculo.tipo_uso, 'tipoUso');
      handleFormChange(
        cotizaciones?.[0]?.vehiculo?.submodelo?.plazas || 0,
        'ocupantes'
      );

      handleFormChange(
        vehiculo.representante ? 'Representante' : 'Importación directa',
        'origen'
      );
      handleFormChange(
        formatoMonedaGenerico(vehiculo.moneda, roundedNumber, undefined),
        'monto'
      );
      if (!fields.departamentoZonaCirculacion) {
        handleFormChange(
          vehiculo.id_departamento ? `${vehiculo.id_departamento}` : null,
          'departamentoZonaCirculacion'
        );
        handleFormChange(
          vehiculo.id_distrito ? `${vehiculo.id_distrito}` : null,
          'distritoZonaCirculacion'
        );
      }

      const monedasConfiguradas = {};
      cotizaciones
        .flatMap((cotiz) => cotiz.planes)
        .forEach((item) => {
          monedasConfiguradas[item.moneda.codigo] = item.moneda;
        });

      const monedaGuaranies = Object.values(monedasConfiguradas).find(
        (item) => item.codigo === 'gs'
      );
      if (!moneda) {
        if (monedaGuaranies) {
          setMoneda(monedaGuaranies);
        } else {
          const codigoPrimeraMoneda = Object.keys(monedasConfiguradas)[0];
          setMoneda(monedasConfiguradas[codigoPrimeraMoneda]);
        }
      }
      setMonedas(Object.values(monedasConfiguradas));
      if (
        vehiculo.id_departamento &&
        (!departamentos || departamentos.length > 0)
      ) {
        getDepartamentos();
      }
    }
  }, [cotizaciones, moneda]);

  useEffect(() => {
    if (fields.marca) {
      getModelos();
    }
  }, [fields.marca]);

  useEffect(() => {
    if (fields.modelo) {
      getAnios();
    }
  }, [fields.modelo]);

  useEffect(() => {
    if (fields.anio) {
      getSubmodelos();
    }
  }, [fields.anio]);

  useEffect(() => {
    if (fields.anio) {
      getAnios();
    }
  }, [fields.anioInscripcion]);

  useEffect(() => {
    window.addEventListener('beforeunload', eventListener);
    return function cleanup() {
      window.removeEventListener('beforeunload', eventListener);
    };
  });

  useEffect(() => {
    if (vigenciaPagosContext) {
      form.setFieldsValue({ vigenciaPago: vigenciaPagosContext.vigencia });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vigenciaPagosContext]);

  useEffect(() => {
    if (selectedCotizacion) {
      const plan = getSelectedPlan();
      verificarAutorizaciones(plan);
    }
  }, [selectedCotizacion]);

  useEffect(() => {
    // Si sube o modifica la cedula frontal, se resetea el valor del numeroo de ceddula modificada
    if (cedula1) {
      setNumeroCedulaModificada(null);
    }
  }, [cedula1, setNumeroCedulaModificada]);

  // tomamos el tipo de venta de la primera cotizacion ya que todas las cotizaciones de un mismo toke deberian tener el mismo tipo de venta
  const isCotizacionesPresencial =
    cotizaciones && cotizaciones.length > 0
      ? cotizaciones[0].tipo_venta === 'presencial'
      : false;

  const marginLeftPrincipal = screens && screens.md === true && 50;
  const marginRightPrincipal = screens && screens.md === true && 10;
  const maxWidthHoja =
    screens?.md === true &&
    maxWidth + marginLeftPrincipal + marginRightPrincipal;

  // todas las cotizaciones de un mismo token tienen el mismo tipo de venta, seleccionamos la primera pero podria ser cualquiera
  const tipoVenta = cotizaciones ? cotizaciones[0]?.tipo_venta : null;
  const cotizacion = getSelectedCotizacion();
  const esCerokm = cotizacion?.vehiculo?.cerokm;

  const handleEditModalEsChapa = () => {
    setIsEditingModalChapa(!isEditingModalChapa);
  };

  const handleModalEsChapaChange = (e) => {
    setTextValueModalChapa(e.target.value);
  };

  const getCliente = async (cedula) => {
    try {
      setLoadingBefore(true);
      const { aseguradora } = cotizaciones.find(
        (item) => item.id === selectedCotizacion
      ).aseguradoraEmpresaProducto.aseguradoraEmpresa;
      const datos = await consultarCliente(
        aseguradora.id,
        cedula,
        selectedCotizacion
      );
      setLoadingBefore(false);
      return datos;
    } catch (e) {
      message.error(e.message);
      setLoadingBefore(false);
      return null;
    }
  };

  const settearDatosCliente = (datos) => {
    const { persona } = datos;
    const tercero = {
      nombres: datos.razonSocial || datos.nombres,
      cedula: datos.cedula,
      ruc: datos.ruc,
      celular: fields.celular,
      domicilio: datos.persona ? datos.persona.domicilio : '',
      correo: datos.persona ? datos.persona.correo : '',
      id_departamento: null,
      id_distrito: null
    };
    handleFormChange(datos.nombres, 'nombres');
    handleFormChange(datos.cedula, 'cedula');
    handleFormChange(datos.ruc, 'ruc');
    handleFormChange(datos.sexo, 'sexo');
    handleFormChange(datos.lugarNacimiento, 'lugarNacimiento');
    handleFormChange(fields.celular && parseCelular(fields.celular), 'celular');

    if (datos.tipoDataBCP) {
      founddatosBCP.nombres = datos.nombres;
      founddatosBCP.cedula = datos.cedula;
      const newdatos = { ...datosBCP, ...founddatosBCP };
      setDatosBCP(newdatos);
    }
    handleFormChange(datos.tipoDataBCP, 'personaBCP');
    handleFormChange(tercero, 'tercero');
    actualizarDatosPersonaByEmpresa({
      persona: {
        ...persona,
        ...datos,
        celular: fields.celular,
        tercero,
        correo: fields?.correo || persona?.correo || ''
      }
    });

    setDatosContactoFromCIA({
      nombres: datos.nombresimg,
      cedula: datos.cedula
    });
    const newdatos = {
      ...datosOriginales,
      ...datosImg,
      cotizacion: {
        departamentoId: datos.cotizacion.departamentoId
          ? datos.cotizacion.departamentoId
          : null,
        distritoId: datos.cotizacion.distritoId
          ? datos.cotizacion.distritoId
          : null,
        domicilio: datos.cotizacion.domicilio
          ? datos.cotizacion.domicilio
          : null
      }
    };
    setDatosOriginales(newdatos);
    setDatosExternosPersona({
      ...datosExternosPersona,
      imagen: {
        ...datosExternosPersona.imagen,
        cedula: datos.cedula,
        nombres: datos.nombresimg,
        sexo: datos.sexo
      },
      bcp: {
        cedula: datos.tipoDataBCP && datos.cedula,
        nombres: datos.nombresBcp,
        fechaNacimiento: datos.fechasBcp,
        nombre: datos.nombreBcp,
        apellido: datos.apellidoBcp
      },
      set: {
        nombres: datos.razonSocial,
        ruc: datos.ruc
      },
      sistemaCore: {
        ...datos.clienteExterno,
        cedula: datos.cedula,
        nombres: datos.clienteExterno && datos.clienteExterno.nombre,
        fechaNacimiento:
          datos.clienteExterno && datos.clienteExterno.fechaNacimiento,
        sexo: datos.clienteExterno && datos.clienteExterno.sexo,
        estadoCivil: datos.clienteExterno && datos.clienteExterno.estado_civil
      }
    });
  };

  const getDatosCliente = async () => {
    const datos = await getCliente(cedulaManualForm.getFieldValue('cedula'));
    settearDatosCliente(datos);
    setSubpasoDocumentos(1);
  };

  return (
    <>
      <ResponsiveContainer
        size={current !== 0 ? 'large' : undefined}
        style={{ maxWidth: current === 0 && maxWidthHoja }}
      >
        <Card>
          <div ref={myRef} />
          {!solicitado && current !== steps.length - 1 && (
            <>
              <div style={{ display: 'flex' }}>
                {isCotizacionesPresencial && current === 0 && (
                  <div style={{ width: '20%' }} />
                )}
                {!solicitado && current !== steps.length - 1 && (
                  <>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%'
                      }}
                    >
                      <Title>{titulo}</Title>
                    </div>
                  </>
                )}
                {isCotizacionesPresencial && current === 0 && (
                  <div
                    style={{
                      width: '20%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <Dropdown
                      menu={dropDownProps}
                      trigger={['click']}
                      disabled={todasCotizacionesPendienteAutorizacion}
                    >
                      <Tooltip
                        title={
                          todasCotizacionesPendienteAutorizacion
                            ? 'No hay cotizaciones autorizadas para imprimir.'
                            : 'Imprimir'
                        }
                      >
                        <Button
                          type="primary"
                          size="large"
                          disabled={todasCotizacionesPendienteAutorizacion}
                        >
                          <Space>
                            <PrinterOutlined style={{ fontSize: '25px' }} />
                            <DownOutlined />
                          </Space>
                        </Button>
                      </Tooltip>
                    </Dropdown>
                  </div>
                )}
              </div>
              {!solicitado &&
                current !== steps.length - 1 &&
                !empresa.tiene_sms && (
                  <>
                    <br />
                    <Badge
                      status="warning"
                      text="El enlace para acceder nuevamente a esta página ha sido enviado a su correo electrónico."
                    />
                  </>
                )}
            </>
          )}
          {(solicitado && smsEnviado && (
            <Result
              status="success"
              title={`¡${
                empresa.tiene_whatsapp && cotizacion.persona?.via_contacto
                  ? 'Whatsapp'
                  : 'SMS'
              } con Link para Aprobación/Firma enviado exitosamente!`}
              subTitle=""
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => {
                    window.location.href = `/`;
                  }}
                >
                  Ir al inicio
                </Button>
              ]}
            />
          )) || (
            <>
              <div>
                {current > 0 && current !== steps.length - 1 && (
                  <StepperSolicitud
                    current={current}
                    steps={steps.slice(0, 3)}
                  />
                )}
              </div>
              {current > 0 && current === steps.length - 1 && (
                <Title>
                  {solicitado && '¡Solicitud enviada!'}
                  {!solicitado && steps[current].description}
                </Title>
              )}
              {current > 0 && current !== steps.length - 1 && (
                <>
                  <br />
                  <Subtitle>{steps[current].description}</Subtitle>
                </>
              )}
              <div>
                {current === 0 && (
                  <div
                    style={{
                      marginLeft: marginLeftPrincipal,
                      marginRight: marginRightPrincipal
                    }}
                  >
                    <SolicitudPlanVigencia
                      loaded={!loadedPlanes}
                      debouncing={debouncing}
                      onDebounce={onDebounce}
                      planSelectorData={{
                        cotizaciones,
                        setSelectedPlan,
                        setSelectedCotizacion,
                        selectedCotizacion,
                        selectedPlan,
                        selectedPlanTipo,
                        setSelectedPlanTipo,
                        selectedMonedaPlan,
                        setSelectedMonedaPlan,
                        loading: loadingPlanes
                      }}
                      opcionesDePago={{
                        numeroCuotas:
                          vigenciaPagosContext?.pagos?.cantidad_pagos
                      }}
                      {...{
                        vigenciaByAseguradoraList,
                        setVigenciaByAseguradoraList
                      }}
                      moneda={moneda}
                      monedas={monedas}
                      setMoneda={setMoneda}
                      vigenciaSugeridaConfig={vigenciaSugeridaConfig}
                      loading={loadingVigenciaSugerida}
                      margintLeftPrincipal={-marginLeftPrincipal}
                      datosExtra={() => (
                        <>
                          {((user && user['cognito:groups'][0] === 'CLIENTE') ||
                            (!user &&
                              (userState === USER_STATES.loggingEnd ||
                                userState === USER_STATES.notLogged))) && (
                            <>
                              <div
                                style={{
                                  maxWidth,
                                  margin: 'auto',
                                  marginBottom: 20
                                }}
                              >
                                <div
                                  style={{
                                    textAlign: 'left',
                                    paddingTop: 20,
                                    paddingBottom: 8
                                  }}
                                >
                                  <strong>
                                    Estimado Sr/Sra
                                    {` ${
                                      cotizaciones?.[0]?.persona?.nombres || ''
                                    }`}{' '}
                                  </strong>
                                </div>
                                <Typography.Paragraph
                                  level={5}
                                  style={{ textAlign: 'left' }}
                                >
                                  {`A continuación encontrará la cotización para su seguro de ${
                                    descripcionProducto || ''
                                  } y los principales
                detalles de la misma.`}
                                </Typography.Paragraph>
                              </div>
                            </>
                          )}

                          {user && user['cognito:groups'][0] !== 'CLIENTE' && (
                            <div
                              style={{
                                maxWidth,
                                margin: 'auto',
                                marginBottom: 20
                              }}
                            >
                              <TitleBar>
                                <>
                                  {screens && screens.md === true && (
                                    <SubSubtitleStart
                                      level={5}
                                      style={{
                                        fontWeight: '500'
                                      }}
                                    >
                                      Datos de Contacto
                                    </SubSubtitleStart>
                                  )}
                                  {screens && screens.md === false && (
                                    <SubSubtitle
                                      level={5}
                                      style={{
                                        fontWeight: '500'
                                      }}
                                    >
                                      Datos de Contacto
                                    </SubSubtitle>
                                  )}
                                </>
                              </TitleBar>
                              <Descriptions
                                bordered
                                size="small"
                                style={{ textAlign: 'left' }}
                                labelStyle={{ width: '20%' }}
                                contentStyle={{ width: '30%' }}
                                column={{ md: 2, sm: 1, xs: 1 }}
                              >
                                <Descriptions.Item label="Nombre" span={2}>
                                  {cotizaciones?.[0]?.persona?.nombres}
                                </Descriptions.Item>
                                <Descriptions.Item label="Nro. de Teléfono">
                                  {cotizaciones?.[0]?.persona?.celular}
                                </Descriptions.Item>
                                <Descriptions.Item label="E-mail">
                                  {cotizaciones?.[0]?.persona?.correo || 'N/A'}
                                </Descriptions.Item>
                              </Descriptions>
                            </div>
                          )}

                          <TitleBar>
                            <>
                              {screens && screens.md === true && (
                                <SubSubtitleStart
                                  level={5}
                                  style={{
                                    fontWeight: '500'
                                  }}
                                >
                                  Datos del vehículo
                                </SubSubtitleStart>
                              )}
                              {screens && screens.md === false && (
                                <SubSubtitle
                                  level={5}
                                  style={{
                                    fontWeight: '500'
                                  }}
                                >
                                  Datos del vehículo
                                </SubSubtitle>
                              )}
                            </>
                          </TitleBar>
                          <Descriptions
                            bordered
                            size="small"
                            style={{ textAlign: 'left' }}
                            column={{ md: 2, sm: 1, xs: 1 }}
                            labelStyle={{ width: '20%' }}
                            contentStyle={{ width: '30%' }}
                          >
                            <Descriptions.Item label="Marca">
                              {cotizaciones?.[0]?.vehiculo?.marca?.descripcion}
                            </Descriptions.Item>
                            <Descriptions.Item label="Modelo">
                              {cotizaciones?.[0]?.vehiculo?.modelo?.descripcion}
                            </Descriptions.Item>
                            <Descriptions.Item label="Submodelo">
                              {
                                cotizaciones?.[0]?.vehiculo?.submodelo
                                  ?.descripcion
                              }
                            </Descriptions.Item>
                            <Descriptions.Item label="Año">
                              {
                                cotizaciones?.[0]?.vehiculo?.aniosubmodelo
                                  ?.descripcion
                              }
                            </Descriptions.Item>
                            <Descriptions.Item label="Valor">
                              {formatoMonedaGenerico(
                                cotizaciones?.[0]?.vehiculo.moneda,
                                cotizaciones?.[0]?.vehiculo.monto_asegurado,
                                undefined
                              )}
                            </Descriptions.Item>
                            <Descriptions.Item label="Tipo de uso">
                              {(cotizaciones?.[0]?.vehiculo?.tipo_uso &&
                                TIPOS_USO_VEHICULO_TODOS.find(
                                  (item) =>
                                    item.codigo ===
                                    cotizaciones?.[0]?.vehiculo?.tipo_uso
                                )?.descripcion) ||
                                'Sin definir'}
                            </Descriptions.Item>
                            <Descriptions.Item label="Combustible">
                              {(cotizaciones?.[0]?.vehiculo?.combustible &&
                                TIPOS_COMBUSTIBLE.find(
                                  (item) =>
                                    item.codigo ===
                                    cotizaciones?.[0]?.vehiculo?.combustible
                                )?.descripcion) ||
                                'Sin definir'}
                            </Descriptions.Item>
                            <Descriptions.Item label="Importación directa">
                              {cotizaciones?.[0]?.vehiculo?.representante
                                ? 'No'
                                : 'Si'}
                            </Descriptions.Item>
                            {!cotizaciones?.[0]?.vehiculo?.representante && (
                              <Descriptions.Item label="Volante cambiado">
                                {cotizaciones?.[0]?.vehiculo?.volante_cambiado
                                  ? 'Si'
                                  : 'No'}
                              </Descriptions.Item>
                            )}

                            <Descriptions.Item label="Cant. ocupantes">
                              {cotizaciones?.[0]?.vehiculo?.submodelo?.plazas ||
                                '0'}
                            </Descriptions.Item>
                            {cotizaciones?.[0]?.vehiculo?.id_departamento && (
                              <>
                                <Descriptions.Item label="Zona principal de circulación">
                                  {getDescripcionDistrito()}
                                  {departamentos.find(
                                    (d) =>
                                      d.id ===
                                      `${cotizaciones?.[0]?.vehiculo?.id_departamento}`
                                  )?.descripcion || ''}
                                </Descriptions.Item>
                              </>
                            )}
                          </Descriptions>
                        </>
                      )}
                    />
                    <br />
                  </div>
                )}
              </div>

              {current === 1 && (
                <>
                  <Spin spinning={loadingBefore} delay={500} size="large">
                    {subpasoDocumentos === 0 && (
                      <>
                        <Row gutter={[16, 8]} justify="center">
                          <Col xs={24} md={24}>
                            <Label>
                              {' '}
                              ¿La póliza/factura deben ser emitidas a nombre de
                              una Persona Jurídica?{' '}
                              <Switch
                                checked={esJuridica}
                                checkedChildren="Si"
                                unCheckedChildren="No"
                                onChange={() => {
                                  setEsJuridica(!esJuridica);
                                }}
                              />
                            </Label>
                          </Col>
                        </Row>
                        {tipoVenta === 'presencial' &&
                          noEsCliente &&
                          !empresa.requiere_cedula && (
                            <Row gutter={[16, 0]} justify="center">
                              <Col xs={24} md={24}>
                                <Label>
                                  {' '}
                                  ¿Prefieres ingresar solamente el número de
                                  cédula?{' '}
                                  <Switch
                                    checked={soloNumCedula}
                                    onChange={() => {
                                      setSoloNumCedula(!soloNumCedula);
                                    }}
                                  />
                                </Label>
                              </Col>
                            </Row>
                          )}
                        <Card size="small">
                          {!esJuridica && !soloNumCedula && (
                            <>
                              <Row
                                gutter={[16, 16]}
                                justify="center"
                                style={{
                                  maxWidth,
                                  marginTop: 'auto',
                                  marginBottom: 'auto',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                  textAlign: 'center'
                                }}
                              >
                                {screens?.md === true && (
                                  <>
                                    <Col md={24} style={colStyles}>
                                      <SubSubtitle>
                                        Cédula de Identidad (Obligatorio)
                                      </SubSubtitle>
                                    </Col>

                                    <Col xs={4} style={colStyles}>
                                      <CedulaAdelanteUpload
                                        formatosImagen={formatosImagen}
                                        cargado={cedula1}
                                        setCargado={setCedula1}
                                        setLoading={setLoading1}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading1}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>

                                    <Col xs={4} style={colStyles}>
                                      <CedulaAtrasUpload
                                        formatosImagen={formatosImagen}
                                        cargado={cedula2}
                                        setCargado={setCedula2}
                                        setLoading={setLoading2}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading2}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                  </>
                                )}
                                {screens?.md === false && (
                                  <>
                                    <Col xs={24} style={colStyles}>
                                      <SubSubtitle>
                                        Cédula de Identidad (Obligatorio)
                                      </SubSubtitle>
                                    </Col>
                                    <Col xs={24} style={colStyles}>
                                      <CedulaAdelanteUpload
                                        formatosImagen={formatosImagen}
                                        cargado={cedula1}
                                        setCargado={setCedula1}
                                        setLoading={setLoading1}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading1}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                    <Col xs={24} style={colStyles}>
                                      <CedulaAtrasUpload
                                        formatosImagen={formatosImagen}
                                        cargado={cedula2}
                                        setCargado={setCedula2}
                                        setLoading={setLoading2}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading2}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                  </>
                                )}
                              </Row>
                            </>
                          )}
                          {esJuridica && (
                            <Label>No es necesario cargar el documento</Label>
                          )}
                          {soloNumCedula && (
                            <Row gutter={[16, 0]} justify="center">
                              <Col
                                xs={24}
                                md={12}
                                lg={6}
                                align="start"
                                style={{
                                  ...colStyles,
                                  marginTop: '50px'
                                }}
                              >
                                <Form
                                  scrollToFirstError
                                  form={cedulaManualForm}
                                  name="cedulaManualForm"
                                  autoComplete="off"
                                  layout="horizontal"
                                >
                                  <Form.Item
                                    label="Cédula de Identidad"
                                    name="cedula"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Requerido'
                                      },
                                      {
                                        pattern: '^[0-9]{5,8}$',
                                        message:
                                          'Verificar formato. Ej.: 12345678'
                                      }
                                    ]}
                                    style={{ textAlign: 'left' }}
                                  >
                                    <Input />
                                  </Form.Item>
                                </Form>
                              </Col>
                            </Row>
                          )}
                        </Card>
                      </>
                    )}
                    {subpasoDocumentos === 0 && (
                      <ReconfirmarCIAModal
                        formCedula={formCedula}
                        mostrarConfirmarCedula={mostrarConfirmarCedula}
                        onClickContinuarCedulaEditada={
                          onClickContinuarCedulaEditada
                        }
                        loading={confirmarCedulaLoading}
                      />
                    )}
                    {subpasoDocumentos === 1 && (
                      <>
                        <Subtitle>2 / 2 - Documentos del Vehículo</Subtitle>
                        <Card>
                          <Modal
                            title="Error en la verificación"
                            open={modalCedulaVerdeInvalida}
                            onCancel={() => setModalCedulaVerdeInvalida(false)}
                            footer={[
                              <Button
                                onClick={() =>
                                  setModalCedulaVerdeInvalida(false)
                                }
                              >
                                Subir otra imagen
                              </Button>,
                              <Button
                                type="primary"
                                onClick={() => {
                                  setModalCedulaVerdeInvalida(false);
                                  setCurrent(current + 1);
                                  scrollTop();
                                }}
                              >
                                Continuar
                              </Button>
                            ]}
                          >
                            <p>
                              La cédula verde no fue reconocida, ¿desea seguir o
                              cargar una nueva imagen?
                            </p>
                          </Modal>
                          <Modal
                            title="Error en la verificación de datos"
                            open={modalEstaEsTuChapa}
                            onCancel={() => setModalEstaEsTuChapa(false)}
                            footer={[
                              <Button
                                key="chapa"
                                type="primary"
                                onClick={() => {
                                  onClickContinuarChapaEditada();
                                }}
                              >
                                Continuar
                              </Button>
                            ]}
                          >
                            <p>¿Esta es tu chapa?</p>
                            <Input
                              value={textValueModalChapa}
                              onChange={handleModalEsChapaChange}
                              disabled={!isEditingModalChapa}
                              suffix={
                                <EditOutlined
                                  onClick={handleEditModalEsChapa}
                                  style={{
                                    color: isEditingModalChapa ? 'blue' : 'grey'
                                  }}
                                />
                              }
                            />
                          </Modal>
                          {esCerokm === 1 && (
                            <Row gutter={[16, 16]} justify="center">
                              <Col xs={24} md={24}>
                                <Label>
                                  ¿El vehículo cuenta con Cédula Verde?{' '}
                                  <Switch
                                    checked={tieneCV}
                                    checkedChildren="Si"
                                    unCheckedChildren="No"
                                    onChange={() => {
                                      setTieneCV(!tieneCV);
                                    }}
                                  />
                                </Label>
                              </Col>
                            </Row>
                          )}
                          {screens?.md === true && (
                            <>
                              <Row
                                gutter={[16, 16]}
                                justify="center"
                                style={{
                                  maxWidth,
                                  marginTop: 'auto',
                                  marginBottom: 'auto',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                  textAlign: 'center'
                                }}
                              >
                                {tieneCV ? (
                                  <>
                                    <Col md={24} style={colStyles}>
                                      <SubSubtitle>
                                        Cédula Verde (Obligatorio)
                                      </SubSubtitle>
                                    </Col>
                                    <Col style={colStyles}>
                                      <CedulaVerdeAdelanteUpload
                                        formatosImagen={formatosImagen}
                                        cargado={cedulaVerde1}
                                        setCargado={setCedulaVerde1}
                                        setLoading={setLoading3}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading3}
                                        uploadFile={uploadFile}
                                        idCotizacion={cotizaciones?.[0]?.id}
                                      />
                                    </Col>
                                    <Col style={colStyles}>
                                      <CedulaVerdeAtrasUpload
                                        formatosImagen={formatosImagen}
                                        cargado={cedulaVerde2}
                                        setCargado={setCedulaVerde2}
                                        setLoading={setLoading4}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading4}
                                        uploadFile={uploadFile}
                                        idCotizacion={cotizaciones?.[0]?.id}
                                      />
                                    </Col>
                                  </>
                                ) : (
                                  <>
                                    <Col md={8} style={colStyles}>
                                      <SubSubtitle>
                                        Chapa Provisoria
                                        <br />
                                        (Obligatorio)
                                      </SubSubtitle>
                                    </Col>
                                    <Col md={8} style={colStyles}>
                                      <SubSubtitle>
                                        Certificado de Nacionalización
                                        <br />
                                        (Obligatorio)
                                      </SubSubtitle>
                                    </Col>
                                    <Col md={8} style={colStyles}>
                                      <SubSubtitle>
                                        Certificado de Venta
                                        <br />
                                        (Obligatorio)
                                      </SubSubtitle>
                                    </Col>
                                    <Col md={8} style={colStyles}>
                                      <ChapaProvisoriaUpload
                                        formatosImagen={formatosImagen}
                                        cargado={chapaProvisoria}
                                        setCargado={setChapaProvisoria}
                                        setLoading={setLoadingChapaProvisoria}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loadingChapaProvisoria}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                    <Col md={8} style={colStyles}>
                                      <CertificadoNacionalizacionUpload
                                        formatosImagen={formatosImagen}
                                        cargado={certificadoNacionalizacion}
                                        setCargado={
                                          setCertificadoNacionalizacion
                                        }
                                        setLoading={
                                          setLoadingCertificadoNacionalizacion
                                        }
                                        setLoadingBefore={setLoadingBefore}
                                        loading={
                                          loadingCertificadoNacionalizacion
                                        }
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                    <Col md={8} style={colStyles}>
                                      <CertificadoVentaUpload
                                        formatosImagen={formatosImagen}
                                        cargado={certificadoVenta}
                                        setCargado={setCertificadoVenta}
                                        setLoading={setLoadingCertificadoVenta}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loadingCertificadoVenta}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                  </>
                                )}
                              </Row>
                              <Row
                                gutter={[16, 16]}
                                justify="center"
                                style={{
                                  maxWidth,
                                  marginTop: 40,
                                  marginBottom: 'auto',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                  textAlign: 'center'
                                }}
                              >
                                <Col md={24} style={colStyles}>
                                  <SubSubtitle>
                                    Habilitación (Opcional)
                                  </SubSubtitle>
                                </Col>

                                <Col xs={24} md={24} style={colStyles}>
                                  <Label>
                                    ¿El vehículo cuenta con Habilitación?{' '}
                                    <Switch
                                      checked={tieneHabilitacion}
                                      checkedChildren="Si"
                                      unCheckedChildren="No"
                                      onChange={() => {
                                        setTieneHabilitacion(
                                          !tieneHabilitacion
                                        );
                                      }}
                                    />
                                  </Label>
                                </Col>
                                {tieneHabilitacion && (
                                  <>
                                    <Col style={colStyles}>
                                      <HabilitacionAdelanteUpload
                                        formatosImagen={formatosImagen}
                                        cargado={habilitacion1}
                                        setCargado={setHabilitacion1}
                                        setLoading={setLoading5}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading5}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                    <Col style={colStyles}>
                                      <HabilitacionAtrasUpload
                                        formatosImagen={formatosImagen}
                                        cargado={habilitacion2}
                                        setCargado={setHabilitacion2}
                                        setLoading={setLoading6}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading6}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                  </>
                                )}
                              </Row>
                            </>
                          )}
                          <Row
                            gutter={[16, 16]}
                            justify="center"
                            style={{
                              maxWidth,
                              marginTop: 'auto',
                              marginBottom: 'auto',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                              textAlign: 'center'
                            }}
                          >
                            {screens?.md === false && (
                              <>
                                {tieneCV ? (
                                  <>
                                    <Col xs={24} style={colStyles}>
                                      <SubSubtitle>
                                        Cédula Verde (Obligatorio)
                                      </SubSubtitle>
                                    </Col>
                                    <Col xs={24} style={colStyles}>
                                      <CedulaVerdeAdelanteUpload
                                        formatosImagen={formatosImagen}
                                        cargado={cedulaVerde1}
                                        setCargado={setCedulaVerde1}
                                        setLoading={setLoading3}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading3}
                                        uploadFile={uploadFile}
                                        idCotizacion={cotizaciones?.[0]?.id}
                                      />
                                    </Col>
                                    <Col xs={24} style={colStyles}>
                                      <CedulaVerdeAtrasUpload
                                        formatosImagen={formatosImagen}
                                        cargado={cedulaVerde2}
                                        setCargado={setCedulaVerde2}
                                        setLoading={setLoading4}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading4}
                                        uploadFile={uploadFile}
                                        idCotizacion={cotizaciones?.[0]?.id}
                                      />
                                    </Col>
                                  </>
                                ) : (
                                  <>
                                    <Col xs={24} style={colStyles}>
                                      <SubSubtitle>
                                        Chapa Provisoria
                                        <br />
                                        (Obligatorio)
                                      </SubSubtitle>
                                    </Col>
                                    <Col xs={24} style={colStyles}>
                                      <ChapaProvisoriaUpload
                                        formatosImagen={formatosImagen}
                                        cargado={chapaProvisoria}
                                        setCargado={setChapaProvisoria}
                                        setLoading={setLoadingChapaProvisoria}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loadingChapaProvisoria}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                    <Col xs={24} style={colStyles}>
                                      <SubSubtitle>
                                        Certificado de Nacionalización
                                        <br />
                                        (Obligatorio)
                                      </SubSubtitle>
                                    </Col>
                                    <Col xs={24} style={colStyles}>
                                      <CertificadoNacionalizacionUpload
                                        formatosImagen={formatosImagen}
                                        cargado={certificadoNacionalizacion}
                                        setCargado={
                                          setCertificadoNacionalizacion
                                        }
                                        setLoading={
                                          setLoadingCertificadoNacionalizacion
                                        }
                                        setLoadingBefore={setLoadingBefore}
                                        loading={
                                          loadingCertificadoNacionalizacion
                                        }
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                    <Col xs={24} style={colStyles}>
                                      <SubSubtitle>
                                        Certificado de Venta
                                        <br />
                                        (Obligatorio)
                                      </SubSubtitle>
                                    </Col>
                                    <Col xs={24} style={colStyles}>
                                      <CertificadoVentaUpload
                                        formatosImagen={formatosImagen}
                                        cargado={certificadoVenta}
                                        setCargado={setCertificadoVenta}
                                        setLoading={setLoadingCertificadoVenta}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loadingCertificadoVenta}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                  </>
                                )}
                                <Col xs={24} style={colStyles}>
                                  <SubSubtitle>
                                    Habilitación (Opcional)
                                  </SubSubtitle>
                                </Col>
                                <Col xs={24} md={24}>
                                  <Label>
                                    ¿El vehículo cuenta con Habilitación?{' '}
                                    <Switch
                                      checked={tieneHabilitacion}
                                      checkedChildren="Si"
                                      unCheckedChildren="No"
                                      onChange={() => {
                                        setTieneHabilitacion(
                                          !tieneHabilitacion
                                        );
                                      }}
                                    />
                                  </Label>
                                </Col>
                                {tieneHabilitacion && (
                                  <>
                                    <Col xs={24} style={colStyles}>
                                      <HabilitacionAdelanteUpload
                                        formatosImagen={formatosImagen}
                                        cargado={habilitacion1}
                                        setCargado={setHabilitacion1}
                                        setLoading={setLoading5}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading5}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                    <Col xs={24} style={colStyles}>
                                      <HabilitacionAtrasUpload
                                        formatosImagen={formatosImagen}
                                        cargado={habilitacion2}
                                        setCargado={setHabilitacion2}
                                        setLoading={setLoading6}
                                        setLoadingBefore={setLoadingBefore}
                                        loading={loading6}
                                        uploadFile={uploadFile}
                                      />
                                    </Col>
                                  </>
                                )}
                              </>
                            )}
                          </Row>
                        </Card>
                      </>
                    )}
                  </Spin>
                </>
              )}
              {current === 2 && (
                <Form
                  name="vehiculo"
                  scrollToFirstError
                  initialValues={fields}
                  layout="vertical"
                  onFinish={onFinish}
                  onFinishFailed={() => onFinishFailed()}
                  form={form}
                  noValidate
                >
                  <Divider>Datos del vehículo</Divider>
                  <br />

                  <Row
                    gutter={[16, 0]}
                    style={{
                      maxWidth,
                      marginTop: 'auto',
                      marginBottom: 'auto',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      textAlign: 'start'
                    }}
                  >
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Marca"
                        name="marca"
                        rules={[{ required: true }]}
                      >
                        <Select
                          disabled
                          showSearch
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          style={{ width: '100%' }}
                          optionFilterProp="children"
                          placeholder="Elegir marca"
                          // value={fields.marca}
                          onChange={(value) => {
                            handleFormChange(value, 'marca');
                            handleFormChange(null, 'modelo');
                            handleFormChange(null, 'submodelo');
                            handleFormChange(null, 'anio');
                            changeData('marca', value);
                          }}
                        >
                          {marcas.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.descripcion}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Modelo"
                        name="modelo"
                        rules={[{ required: true }]}
                      >
                        <Select
                          disabled
                          showSearch
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          style={{ width: '100%' }}
                          placeholder="Elegir modelo"
                          // value={fields.modelo}
                          onChange={(value) => {
                            handleFormChange(value, 'modelo');
                            handleFormChange(null, 'submodelo');
                            handleFormChange(null, 'anio');
                            changeData('modelo', value);
                          }}
                        >
                          {modelos.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.descripcion}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Año"
                        name="anio"
                        rules={[{ required: true }]}
                      >
                        <Select
                          disabled
                          showSearch
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          style={{ width: '100%' }}
                          placeholder="Elegir año"
                          // value={fields.anio}
                          onChange={(value) => {
                            handleFormChange(value, 'anio');
                            handleFormChange(null, 'submodelo');
                            changeData('anio', value);
                          }}
                        >
                          {anios.map((item) => (
                            <Option
                              key={item.descripcion}
                              value={item.descripcion}
                            >
                              {item.descripcion}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Submodelo"
                        name="submodelo"
                        dependencies={['anio']}
                        rules={[{ required: true }]}
                      >
                        <Select
                          disabled
                          showSearch
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          style={{ width: '100%' }}
                          placeholder="Elegir submodelo"
                          // value={fields.submodelo}
                          onChange={(value) => {
                            verificarCombustible(value);
                            handleFormChange(value, 'submodelo');
                            changeData('submodelo', value);
                          }}
                        >
                          {submodelos.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.descripcion}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item noStyle shouldUpdate>
                        {() => {
                          return (
                            <Form.Item
                              label="Combustible"
                              name="combustible"
                              rules={[
                                {
                                  required: true,
                                  message: 'Debe indicar el combustible'
                                }
                              ]}
                              onChange={(e) => {
                                handleFormChange(e.target.value, 'combustible');
                                changeData('combustible', e.target.value);
                              }}
                            >
                              <Radio.Group
                                disabled
                                // disabled={
                                //   getFieldValue('submodelo') &&
                                //   submodelos &&
                                //   reconocerCombustible(
                                //     getFieldValue('submodelo'),
                                //     submodelos
                                //   )
                                // }
                              >
                                {TIPOS_COMBUSTIBLE.map((item) => (
                                  <Radio key={item.codigo} value={item.codigo}>
                                    {item.descripcion}
                                  </Radio>
                                ))}
                              </Radio.Group>
                            </Form.Item>
                          );
                        }}
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item noStyle shouldUpdate>
                        {() => {
                          return (
                            <Form.Item
                              label="Tipo de Uso"
                              name="tipoUso"
                              rules={[
                                {
                                  required: true,
                                  message:
                                    'Debe indicar el tipo de uso del vehículo'
                                }
                              ]}
                            >
                              <Radio.Group disabled>
                                {form.getFieldValue('tipoUso') &&
                                TIPOS_USO_VEHICULO.some(
                                  (item) =>
                                    item.codigo ===
                                    form.getFieldValue('tipoUso')
                                )
                                  ? TIPOS_USO_VEHICULO.map((item) => (
                                      <Radio
                                        key={item.codigo}
                                        value={item.codigo}
                                      >
                                        {item.descripcion}
                                      </Radio>
                                    ))
                                  : TIPOS_USO_VEHICULO_TODOS.map(
                                      (item) =>
                                        item.codigo !== 'OTROS' && (
                                          <Radio
                                            key={item.codigo}
                                            value={item.codigo}
                                          >
                                            {item.descripcion}
                                          </Radio>
                                        )
                                    )}
                              </Radio.Group>
                            </Form.Item>
                          );
                        }}
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Monto"
                        name="monto"
                        rules={[{ required: true }]}
                      >
                        <Input disabled type="string" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Origen"
                        name="origen"
                        rules={[{ required: true }]}
                      >
                        <Input
                          disabled
                          // value={fields.origen === 1 ? "Representante" : "Importación directa"}
                          type="string"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Chassis"
                        name="chassis"
                        rules={[{ required: true }]}
                      >
                        <Input
                          placeholder="Ingrese un valor"
                          onChange={(value) => {
                            handleFormChange(value.target.value, 'chassis');
                            changeData('chassis', value.target.value);
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Color"
                        name="color"
                        rules={[
                          { required: true },
                          {
                            validator: () => {
                              if (
                                !fields.color ||
                                (fields.color === 'OTRO' && !fields.otroColor)
                              ) {
                                // eslint-disable-next-line prefer-promise-reject-errors
                                return Promise.reject(
                                  `Este campo es requerido`
                                );
                              }

                              return Promise.resolve();
                            }
                          }
                        ]}
                      >
                        <Input.Group compact>
                          <Form.Item name="color" noStyle>
                            <Select
                              allowClear
                              style={{ width: '50%' }}
                              placeholder="Elegir un color"
                              onChange={(e) => {
                                handleFormChange(e, 'color');
                              }}
                            >
                              {colores.map(({ descripcion }) => (
                                <Option key={descripcion} value={descripcion}>
                                  {descripcion}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          {fields.color === 'OTRO' && (
                            <Form.Item name="otroColor" noStyle>
                              <Input
                                allowClear
                                style={{
                                  width: '50%',
                                  textTransform: 'uppercase'
                                }}
                                placeholder="Escriba aquí"
                                onChange={(e) => {
                                  handleFormChange(e.target.value, 'otroColor');
                                }}
                              />
                            </Form.Item>
                          )}
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} hidden={!!vehiculoBCP}>
                      <Form.Item label="Cantidad de ocupantes" name="ocupantes">
                        <InputNumber disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Chapa"
                        name="chapa"
                        rules={[
                          { required: true },
                          {
                            min: 6,
                            message: 'La longitud mínima es de 6 caracteres'
                          }
                        ]}
                        onChange={(e) => {
                          handleInputChange('chapa', e);
                        }}
                      >
                        <Input
                          placeholder="Ingrese un valor"
                          maxLength={7}
                          onChange={(value) => {
                            handleFormChange(value.target.value, 'chapa');
                            changeData('chapa', value.target.value);
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} hidden={!vehiculoBCP}>
                      <Form.Item label="Cantidad de ocupantes" name="ocupantes">
                        <InputNumber disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                  {tieneAutorizacionPorTipo('ZONA') && (
                    <>
                      <Divider>Zona Principal de Circulación</Divider>
                      <Row
                        gutter={[16, 0]}
                        style={{
                          maxWidth,
                          marginTop: 'auto',
                          marginBottom: 'auto',
                          marginLeft: 'auto',
                          marginRight: 'auto'
                        }}
                      >
                        <Col
                          xs={24}
                          md={12}
                          align="start"
                          style={{ textAlign: 'left' }}
                        >
                          <Form.Item
                            label="Departamento"
                            name="departamentoZonaCirculacion"
                            rules={[{ required: true, message: 'Requerido' }]}
                          >
                            <Select
                              showSearch
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              style={{ width: '100%' }}
                              optionFilterProp="children"
                              placeholder="Elegir departamento"
                              onChange={(value) => {
                                handleFormChange(
                                  value,
                                  'departamentoZonaCirculacion'
                                );
                                handleFormChange(
                                  null,
                                  'distritoZonaCirculacion'
                                );
                                form.setFieldsValue({
                                  departamentoZonaCirculacion: value,
                                  distritoZonaCirculacion: null
                                });
                                setDistritosZonaCirculacion([]);
                                getDistritos({
                                  departamentoZonaCirculacion: value
                                });
                              }}
                            >
                              {departamentos.map((item) => (
                                <Option key={item.id} value={item.id}>
                                  {item.descripcion}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col
                          xs={24}
                          md={12}
                          align="start"
                          style={{ textAlign: 'left' }}
                        >
                          <Form.Item
                            label="Ciudad"
                            name="distritoZonaCirculacion"
                            rules={[{ required: true, message: 'Requerido' }]}
                          >
                            <Select
                              showSearch
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              style={{ width: '100%' }}
                              placeholder="Elegir distrito"
                              onChange={(value) => {
                                handleFormChange(
                                  value,
                                  'distritoZonaCirculacion'
                                );
                              }}
                            >
                              {distritosZonaCirculacion.map((item) => (
                                <Option key={item.id} value={item.id}>
                                  {item.descripcion}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}
                  <>
                    {esJuridica && (
                      <>
                        <Divider>Confirme Datos del Asegurado</Divider>
                        <Row
                          gutter={[16, 0]}
                          style={{
                            maxWidth,
                            marginTop: 'auto',
                            marginBottom: 'auto',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                          }}
                        >
                          <>
                            <Col xs={24} md={12} align="start">
                              <Form.Item
                                label="Razón Social"
                                name={['empresaJuridica', 'razon']}
                                rules={[
                                  { required: true, message: 'Requerido' }
                                ]}
                                onChange={(e) => {
                                  handleFormTerceroChange(
                                    e.target.value,
                                    'nombres'
                                  );
                                }}
                              >
                                <Input
                                  placeholder="Ingrese un valor"
                                  onChange={(e) =>
                                    handleFormEmpresaJuridicaChange(
                                      e.target.value,
                                      'razon'
                                    )
                                  }
                                  disabled={!!rucJuridicaBCP}
                                />
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12} align="start">
                              <Form.Item
                                label="RUC"
                                name={['empresaJuridica', 'ruc']}
                                rules={[
                                  { required: true, message: 'Requerido' },
                                  {
                                    pattern: '^[0-9]{5,8}-[0-9]{1}$',
                                    message:
                                      'Verificar formato. Ej.: 12345678-9'
                                  },
                                  {
                                    validator: (_, value) => {
                                      if (value.includes('-')) {
                                        const digitoValido = verificarDigito(
                                          value
                                        );
                                        if (!digitoValido) {
                                          // eslint-disable-next-line prefer-promise-reject-errors
                                          return Promise.reject(
                                            `El dígito verificador no coincide`
                                          );
                                        }
                                      }

                                      return Promise.resolve();
                                    }
                                  }
                                ]}
                                validateTrigger="onBlur"
                                onChange={(e) => {
                                  handleFormTerceroChange(
                                    e.target.value,
                                    'ruc'
                                  );
                                }}
                              >
                                <Input
                                  placeholder="Ingrese un valor"
                                  onChange={(event) => {
                                    const ruc = event.target.value;
                                    if (
                                      ruc &&
                                      ruc.match(/^[0-9]{5,8}-[0-9]{1}$/)
                                    ) {
                                      debounceFormRucChange(ruc);
                                      handleFormEmpresaJuridicaChange(
                                        ruc,
                                        'ruc'
                                      );
                                    }
                                  }}
                                  disabled={!!rucJuridicaBCP}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12} align="start">
                              <Form.Item
                                label="Dirección"
                                name={['empresaJuridica', 'domicilio']}
                                onChange={(e) => {
                                  handleFormTerceroChange(
                                    e.target.value,
                                    'domicilio'
                                  );
                                }}
                              >
                                <Input
                                  placeholder="Ingrese un valor"
                                  onChange={(e) =>
                                    handleFormEmpresaJuridicaChange(
                                      e.target.value,
                                      'domicilio'
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12} align="start">
                              <Form.Item
                                label="Correo"
                                name={['empresaJuridica', 'correo']}
                                rules={[
                                  {
                                    type: 'email',
                                    message: 'El correo no es válido'
                                  }
                                ]}
                                onChange={(e) => {
                                  handleFormTerceroChange(
                                    e.target.value,
                                    'correo'
                                  );
                                }}
                              >
                                <Input
                                  placeholder="Ingrese un valor"
                                  onChange={(e) =>
                                    handleFormEmpresaJuridicaChange(
                                      e.target.value,
                                      'correo'
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                          </>
                        </Row>
                      </>
                    )}

                    {!esJuridica && (
                      <>
                        <Divider>Confirme Datos del Asegurado</Divider>
                        <br />
                        <Row
                          gutter={[16, 0]}
                          style={{
                            maxWidth,
                            marginTop: 'auto',
                            marginBottom: 'auto',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            textAlign: 'start'
                          }}
                        >
                          {' '}
                          {/* <Col xs={24} md={12}>
                            <Form.Item
                              label="Nombre y Apellido"
                              name="nombres"
                              validateStatus={
                                datosOriginales.score > 0.1
                                  ? 'warning'
                                  : undefined
                              }
                              rules={[{ required: true }]}
                              onKeyPress={(e) => {
                                const pressedKey = String.fromCharCode(
                                  !e.charCode ? e.which : e.charCode
                                );
                                validarCaracterEspecial(e, pressedKey);
                              }}
                              onPaste={(e) => {
                                const pastedText = e.clipboardData.getData(
                                  'text'
                                );
                                validarCaracterEspecial(e, pastedText);
                              }}
                              onChange={(e) => {
                                handleInputChange('nombres', e);
                                changeData('nombres', e.target.value);
                              }}
                            >
                              <Input
                                placeholder="Ingrese un valor"
                                suffix={
                                  datosOriginales.score > 0.1 && (
                                    <Tooltip
                                      placement="top"
                                      title="Verificar Nombre y Apellido"
                                    >
                                      <InfoCircleOutlined />
                                    </Tooltip>
                                  )
                                }
                                // value={fields.nombre}
                                onChange={(e) => {
                                  changeData('nombres', e);
                                  handleFormChange(e.target.value, 'nombres');
                                  form.setFieldsValue({
                                    nombres: e.target.value
                                  });
                                  if (!esJuridica) {
                                    handleFormTerceroChange(
                                      e.target.value,
                                      'nombres'
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col> */}
                          <Col xs={24} md={6}>
                            <Form.Item
                              label="Nombres"
                              name="nombre"
                              validateStatus={
                                datosOriginales.score > 0.1
                                  ? 'warning'
                                  : undefined
                              }
                              rules={[{ required: true }]}
                              onKeyPress={(e) => {
                                const pressedKey = String.fromCharCode(
                                  !e.charCode ? e.which : e.charCode
                                );
                                validarCaracterEspecial(e, pressedKey);
                              }}
                              onPaste={(e) => {
                                const pastedText = e.clipboardData.getData(
                                  'text'
                                );
                                validarCaracterEspecial(e, pastedText);
                              }}
                              onChange={(e) => {
                                handleInputChange('nombre', e);
                                changeData('nombre', e.target.value);
                              }}
                            >
                              <Input
                                placeholder="Ingrese un valor"
                                suffix={
                                  datosOriginales.score > 0.1 && (
                                    <Tooltip
                                      placement="top"
                                      title="Verificar Nombre y Apellido"
                                    >
                                      <InfoCircleOutlined />
                                    </Tooltip>
                                  )
                                }
                                // value={fields.nombre}
                                onChange={(e) => {
                                  changeData('nombre', e);
                                  handleFormChange(e.target.value, 'nombre');
                                  form.setFieldsValue({
                                    nombres: e.target.value
                                  });
                                  if (!esJuridica) {
                                    handleFormTerceroChange(
                                      e.target.value,
                                      'nombre'
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={6}>
                            <Form.Item
                              label="Apellidos"
                              name="apellido"
                              validateStatus={
                                datosOriginales.score > 0.1
                                  ? 'warning'
                                  : undefined
                              }
                              rules={[{ required: true }]}
                              onKeyPress={(e) => {
                                const pressedKey = String.fromCharCode(
                                  !e.charCode ? e.which : e.charCode
                                );
                                validarCaracterEspecial(e, pressedKey);
                              }}
                              onPaste={(e) => {
                                const pastedText = e.clipboardData.getData(
                                  'text'
                                );
                                validarCaracterEspecial(e, pastedText);
                              }}
                              onChange={(e) => {
                                handleInputChange('apellido', e);
                                changeData('apellido', e.target.value);
                              }}
                            >
                              <Input
                                placeholder="Ingrese un valor"
                                suffix={
                                  datosOriginales.score > 0.1 && (
                                    <Tooltip
                                      placement="top"
                                      title="Verificar Nombre y Apellido"
                                    >
                                      <InfoCircleOutlined />
                                    </Tooltip>
                                  )
                                }
                                // value={fields.nombre}
                                onChange={(e) => {
                                  changeData('apellido', e);
                                  handleFormChange(e.target.value, 'apellido');
                                  form.setFieldsValue({
                                    apellido: e.target.value
                                  });
                                  if (!esJuridica) {
                                    handleFormTerceroChange(
                                      e.target.value,
                                      'apellido'
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Cédula"
                              name="cedula"
                              rules={[{ required: true }]}
                              onChange={(e) => {
                                handleInputChange('cedula', e);
                                changeData('cedula', e.target.value);
                              }}
                            >
                              <Input
                                placeholder="Ingrese un valor"
                                onChange={async (e) => {
                                  changeData('cedula', e.target.value);
                                }}
                                onBlur={async (e) => {
                                  formChange(e.target.value, 'cedula');
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="RUC (Opcional)"
                              name="ruc"
                              rules={[
                                {
                                  pattern: '^[0-9]{5,8}-[0-9]{1}$',
                                  message: 'Verificar formato. Ej.: 12345678-9'
                                },
                                {
                                  validator: (_, value) => {
                                    if (value.length > 0) {
                                      const digitoValido = verificarDigito(
                                        value
                                      );
                                      if (!digitoValido) {
                                        // eslint-disable-next-line prefer-promise-reject-errors
                                        return Promise.reject(
                                          `El dígito verificador no coincide`
                                        );
                                      }
                                    }

                                    return Promise.resolve();
                                  }
                                }
                              ]}
                              validateTrigger="onBlur"
                            >
                              <Input
                                placeholder="Ej.: 12345678-9"
                                // value={ruc}
                                onChange={(e) => {
                                  handleFormChange(e.target.value, 'ruc');

                                  handleFormTerceroChange(
                                    e.target.value,
                                    'ruc'
                                  );
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Celular"
                              name="celular"
                              rules={[{ required: true }]}
                            >
                              <InputMask
                                mask="(999) 999-999"
                                placeholder="(___) ___-___"
                                addonBefore={fields.prefix}
                                onChange={(e) => {
                                  handleFormChange(e.target.value, 'celular');
                                  if (!esJuridica) {
                                    handleFormTerceroChange(
                                      e.target.value,
                                      'celular'
                                    );
                                  }
                                }}
                                disabled
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Correo"
                              name="correo"
                              validateTrigger="onBlur"
                              rules={[
                                { required: true },
                                {
                                  type: 'email',
                                  message: 'El correo no es válido'
                                }
                              ]}
                            >
                              <Input
                                placeholder="Ingrese un valor"
                                // value={fields.correo}
                                onBlur={(e) => {
                                  handleFormChange(e.target.value, 'correo');

                                  handleFormTerceroChange(
                                    e.target.value,
                                    'correo'
                                  );
                                }}
                                onChange={(e) => {
                                  handleFormTerceroChange(
                                    e.target.value,
                                    'correo'
                                  );
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Departamento"
                              name="departamento"
                              rules={[{ required: true, message: 'Requerido' }]}
                            >
                              <Select
                                showSearch
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                style={{ width: '100%' }}
                                optionFilterProp="children"
                                placeholder="Elegir departamento"
                                onChange={(value) => {
                                  handleFormChange(value, 'departamento');
                                  handleFormChange(null, 'distrito');
                                  form.setFieldsValue({
                                    departamento: value,
                                    distrito: null
                                  });
                                  setDistritos([]);
                                  getDistritos({ departamento: value });
                                  geocalizarAsegurado();

                                  handleFormTerceroChange(
                                    value,
                                    'id_departamento'
                                  );
                                  handleFormTerceroChange(null, 'id_distrito');
                                  getDistritos({
                                    departamentoTercero: value
                                  });
                                }}
                              >
                                {departamentos.map((item) => (
                                  <Option key={item.id} value={item.id}>
                                    {item.descripcion}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Ciudad"
                              name="distrito"
                              rules={[{ required: true, message: 'Requerido' }]}
                            >
                              <Select
                                showSearch
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                style={{ width: '100%' }}
                                placeholder="Elegir distrito"
                                onChange={(value) => {
                                  handleFormChange(value, 'distrito');
                                  geocalizarAsegurado();
                                }}
                              >
                                {distritos.map((item) => (
                                  <Option key={item.id} value={item.id}>
                                    {item.descripcion}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Domicilio"
                              name="domicilio"
                              rules={[{ required: true, message: 'Requerido' }]}
                            >
                              <Input
                                placeholder="Ingrese un valor"
                                // value={fields.domicilio}
                                onChange={(e) => {
                                  handleFormChange(e.target.value, 'domicilio');
                                  if (!esJuridica) {
                                    handleFormTerceroChange(
                                      e.target.value,
                                      'domicilio'
                                    );
                                  }
                                  geocalizarAsegurado();
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item label="Nacionalidad" name="nacionalidad">
                              <Select
                                style={{ width: '100%' }}
                                placeholder="Elegir un valor"
                                onChange={(e) => {
                                  handleFormChange(e, 'nacionalidad');
                                }}
                              >
                                {NACIONALIDADES.map(({ descripcion }) => (
                                  <Option key={descripcion} value={descripcion}>
                                    {descripcion}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Sexo"
                              name="sexo"
                              rules={[{ required: true }]}
                            >
                              <Select
                                // value={fields.sexo}
                                style={{ width: '100%' }}
                                placeholder="Elegir sexo"
                                onChange={(value) => {
                                  handleFormChange(value, 'sexo');
                                }}
                              >
                                <Option value="Masculino">Masculino</Option>
                                <Option value="Femenino">Femenino</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Estado civil"
                              name="estadoCivil"
                              rules={[{ required: true }]}
                            >
                              <Select
                                style={{ width: '100%' }}
                                placeholder="Elegir un estado civil"
                                onChange={(e) => {
                                  handleFormChange(e, 'estadoCivil');
                                }}
                              >
                                {ESTADOS.map(({ descripcion }) => (
                                  <Option key={descripcion} value={descripcion}>
                                    {descripcion}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Lugar Nacimiento"
                              name="lugarNacimiento"
                            >
                              <Input
                                placeholder="Ingrese un valor"
                                // value={fields.lugarNacimiento}
                                onChange={(e) =>
                                  handleFormChange(
                                    e.target.value,
                                    'lugarNacimiento'
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Fecha Nacimiento"
                              name="fechaNacimiento"
                              rules={[{ required: true }]}
                              onChange={onChangeDatePicket}
                            >
                              <CustomDatePicker
                                style={{ width: '100%' }}
                                placeholder="DD/MM/YYYY"
                                format="DD/MM/YYYY"
                                onChange={(value) => {
                                  handleFormChange(value, 'fechaNacimiento');
                                  changeData('fechaNacimiento', value);
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <br />
                        </Row>
                      </>
                    )}

                    <Divider>Confirme Datos de Facturación</Divider>
                    <Row gutter={[16, 0]} style={{ maxWidth, margin: 'auto' }}>
                      <Col xs={24} md={12} align="start">
                        <Form.Item
                          label="Razón Social"
                          name={['tercero', 'nombres']}
                          rules={[{ required: true, message: 'Requerido' }]}
                        >
                          <Input
                            placeholder="Ingrese un valor"
                            onChange={(value) => {
                              handleFormTerceroChange(
                                value.target.value,
                                'nombres'
                              );
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12} align="start">
                        <Form.Item
                          label="CI / RUC"
                          name={['tercero', 'ruc']}
                          rules={[
                            { required: true, message: 'Requerido' },
                            {
                              validator: (_, value) => {
                                if (value && value.includes('-')) {
                                  const digitoValido = verificarDigito(value);
                                  if (!digitoValido) {
                                    // eslint-disable-next-line prefer-promise-reject-errors
                                    return Promise.reject(
                                      `El dígito verificador no coincide`
                                    );
                                  }
                                }

                                return Promise.resolve();
                              }
                            }
                          ]}
                          validateTrigger="onBlur"
                        >
                          <Input
                            placeholder="Ej.: 12345678-9"
                            onBlur={(e) => {
                              const ruc = e.target.value;
                              if (ruc && ruc.match(/^[0-9]{5,8}(-[0-9])?$/)) {
                                onBlurRucSet(ruc);
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12} align="start">
                        <Form.Item
                          label="Correo"
                          name={['tercero', 'correo']}
                          rules={[
                            {
                              type: 'email',
                              message: 'El correo no es válido'
                            }
                          ]}
                        >
                          <Input
                            placeholder="Ingrese un valor"
                            type="email"
                            onChange={(value) => {
                              handleFormTerceroChange(
                                value.target.value,
                                'correo'
                              );
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12} align="start">
                        <Form.Item
                          label="Departamento"
                          name={['tercero', 'id_departamento']}
                        >
                          <Select
                            showSearch
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            style={{ width: '100%' }}
                            optionFilterProp="children"
                            placeholder="Elegir departamento"
                            onChange={(value) => {
                              handleFormTerceroChange(value, 'id_departamento');
                              handleFormTerceroChange(null, 'id_distrito');

                              setDistritosTercero([]);
                              getDistritos({ departamentoTercero: value });
                            }}
                          >
                            {departamentos.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.descripcion}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12} align="start">
                        <Form.Item
                          label="Ciudad"
                          name={['tercero', 'id_distrito']}
                        >
                          <Select
                            showSearch
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            style={{ width: '100%' }}
                            placeholder="Elegir distrito"
                            onChange={(value) => {
                              handleFormTerceroChange(value, 'id_distrito');
                            }}
                          >
                            {distritosTercero.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.descripcion}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12} align="start">
                        <Form.Item
                          label="Dirección"
                          name={['tercero', 'domicilio']}
                        >
                          <Input
                            placeholder="Ingrese un valor"
                            onChange={(value) => {
                              handleFormTerceroChange(
                                value.target.value,
                                'domicilio'
                              );
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12} align="start">
                        <Form.Item
                          label="Celular"
                          name={['tercero', 'celular']}
                          rules={[
                            {
                              pattern: `^\\((${prefijos3Digitos.join(
                                '|'
                              )})\\) [0-9]{3}-[0-9]{3}$`,
                              message: 'Número no válido'
                            }
                          ]}
                        >
                          <InputMask
                            mask="(999) 999-999"
                            placeholder="(___) ___-___ (OPCIONAL)"
                            addonBefore="+595"
                            onChange={(value) => {
                              handleFormTerceroChange(
                                value.target.value,
                                'celular'
                              );
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12} align="start">
                        <Form.Item
                          label="Teléfono (Línea Baja)"
                          onKeyPress={validarCaracterTelefono}
                          onPaste={validarCaracterTelefono}
                        >
                          <Input.Group compact>
                            <Form.Item
                              name={[
                                'tercero',
                                'grupoTelefono',
                                'prefijoTelefono'
                              ]}
                              noStyle
                              rules={[
                                {
                                  min: 3,
                                  message: 'Como mínimo debe contener 3 dígitos'
                                },
                                {
                                  max: 4,
                                  message: 'Como máximo debe contener 4 dígitos'
                                }
                              ]}
                            >
                              <Input
                                placeholder="0531"
                                style={{ width: '25%' }}
                                onChange={(e) => {
                                  setPrefijoTelefono(e.target.value);
                                }}
                                onBlur={(e) => {
                                  handleFormTerceroChange(
                                    e.target,
                                    'grupoTelefono',
                                    'prefijoTelefono'
                                  );
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              name={[
                                'tercero',
                                'grupoTelefono',
                                'sufijoTelefono'
                              ]}
                              noStyle
                              rules={[
                                {
                                  min: 5,
                                  message: 'Como mínimo debe contener 5 dígitos'
                                }
                              ]}
                            >
                              <Input
                                placeholder="000 000"
                                style={{ width: '75%' }}
                                onChange={(e) => {
                                  setSufijoTelefono(e.target.value);
                                }}
                                onBlur={(e) => {
                                  handleFormTerceroChange(
                                    e.target,
                                    'grupoTelefono',
                                    'sufijoTelefono'
                                  );
                                }}
                              />
                            </Form.Item>
                          </Input.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                    {esJuridica && (
                      <>
                        <Divider>
                          Confirme los Datos Personales del REPRESENTANTE LEGAL
                          / FIRMANTE
                        </Divider>
                        <br />
                        <Row
                          gutter={[16, 0]}
                          style={{
                            maxWidth,
                            marginTop: 'auto',
                            marginBottom: 'auto',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            textAlign: 'start'
                          }}
                        >
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Nombre y Apellido"
                              name="nombres"
                              validateStatus={
                                datosOriginales.score > 0.1
                                  ? 'warning'
                                  : undefined
                              }
                              rules={[{ required: true }]}
                              onKeyPress={(e) => {
                                const pressedKey = String.fromCharCode(
                                  !e.charCode ? e.which : e.charCode
                                );
                                validarCaracterEspecial(e, pressedKey);
                              }}
                              onPaste={(e) => {
                                const pastedText = e.clipboardData.getData(
                                  'text'
                                );
                                validarCaracterEspecial(e, pastedText);
                              }}
                              onChange={(e) => {
                                handleInputChange('nombres', e);
                              }}
                            >
                              <Input
                                placeholder="Ingrese un valor"
                                // value={fields.nombre}
                                onChange={(e) => {
                                  handleFormChange(e.target.value, 'nombres');
                                  form.setFieldsValue({
                                    nombres: e.target.value
                                  });
                                  if (!esJuridica) {
                                    handleFormTerceroChange(
                                      e.target.value,
                                      'nombres'
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Cédula"
                              name="cedula"
                              rules={[{ required: true }]}
                              onChange={(e) => {
                                handleInputChange('cedula', e);
                              }}
                            >
                              <Input
                                placeholder="Ingrese un valor"
                                onChange={async (e) => {
                                  debounceFormChange(e.target.value, 'cedula');
                                }}
                              />
                            </Form.Item>
                          </Col>
                          {empresa.seprelad && (
                            <Col xs={24} md={12}>
                              <Form.Item
                                label="RUC (Opcional)"
                                name="ruc"
                                rules={[
                                  {
                                    pattern: '^[0-9]{5,8}-[0-9]{1}$',
                                    message:
                                      'Verificar formato. Ej.: 12345678-9'
                                  },
                                  {
                                    validator: (_, value) => {
                                      if (value.lenth > 0) {
                                        const digitoValido = verificarDigito(
                                          value
                                        );
                                        if (!digitoValido) {
                                          // eslint-disable-next-line prefer-promise-reject-errors
                                          return Promise.reject(
                                            `El dígito verificador no coincide`
                                          );
                                        }
                                      }

                                      return Promise.resolve();
                                    }
                                  }
                                ]}
                                validateTrigger="onBlur"
                              >
                                <Input
                                  placeholder="Ej.: 12345678-9"
                                  // value={ruc}
                                  onChange={(e) => {
                                    handleFormChange(e.target.value, 'ruc');
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          )}
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Celular"
                              name="celular"
                              rules={[{ required: true }]}
                            >
                              <InputMask
                                mask="(999) 999-999"
                                placeholder="(___) ___-___"
                                addonBefore={fields.prefix}
                                onChange={(e) => {
                                  handleFormChange(e.target.value, 'celular');
                                  if (!esJuridica) {
                                    handleFormTerceroChange(
                                      e.target.value,
                                      'celular'
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          {empresa.seprelad && (
                            <>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Correo"
                                  name="correo"
                                  validateTrigger="onBlur"
                                  rules={[
                                    { required: true },
                                    {
                                      type: 'email',
                                      message: 'El correo no es válido'
                                    }
                                  ]}
                                >
                                  <Input
                                    placeholder="Ingrese un valor"
                                    // value={fields.correo}
                                    onBlur={(e) => {
                                      handleFormChange(
                                        e.target.value,
                                        'correo'
                                      );
                                      if (!esJuridica) {
                                        handleFormTerceroChange(
                                          e.target.value,
                                          'correo'
                                        );
                                      }
                                    }}
                                    onChange={(e) => {
                                      if (!esJuridica) {
                                        handleFormTerceroChange(
                                          e.target.value,
                                          'correo'
                                        );
                                      }
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Departamento"
                                  name="departamento"
                                  rules={[
                                    { required: true, message: 'Requerido' }
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    style={{ width: '100%' }}
                                    optionFilterProp="children"
                                    placeholder="Elegir departamento"
                                    onChange={(value) => {
                                      handleFormChange(value, 'departamento');
                                      handleFormChange(null, 'distrito');
                                      form.setFieldsValue({
                                        departamento: value,
                                        distrito: null
                                      });
                                      setDistritos([]);
                                      getDistritos({ departamento: value });
                                      geocalizarAsegurado();
                                    }}
                                  >
                                    {departamentos.map((item) => (
                                      <Option key={item.id} value={item.id}>
                                        {item.descripcion}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Ciudad"
                                  name="distrito"
                                  rules={[
                                    { required: true, message: 'Requerido' }
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    style={{ width: '100%' }}
                                    placeholder="Elegir distrito"
                                    onChange={(value) => {
                                      handleFormChange(value, 'distrito');
                                      geocalizarAsegurado();
                                    }}
                                  >
                                    {distritos.map((item) => (
                                      <Option key={item.id} value={item.id}>
                                        {item.descripcion}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Domicilio"
                                  name="domicilio"
                                  rules={[
                                    { required: true, message: 'Requerido' }
                                  ]}
                                >
                                  <Input
                                    placeholder="Ingrese un valor"
                                    // value={fields.domicilio}
                                    onChange={(e) => {
                                      handleFormChange(
                                        e.target.value,
                                        'domicilio'
                                      );
                                      if (!esJuridica) {
                                        handleFormTerceroChange(
                                          e.target.value,
                                          'domicilio'
                                        );
                                      }
                                      geocalizarAsegurado();
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Nacionalidad"
                                  name="nacionalidad"
                                >
                                  <Select
                                    style={{ width: '100%' }}
                                    placeholder="Elegir un valor"
                                    onChange={(e) => {
                                      handleFormChange(e, 'nacionalidad');
                                    }}
                                  >
                                    {NACIONALIDADES.map(({ descripcion }) => (
                                      <Option
                                        key={descripcion}
                                        value={descripcion}
                                      >
                                        {descripcion}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Sexo"
                                  name="sexo"
                                  rules={[{ required: true }]}
                                >
                                  <Select
                                    // value={fields.sexo}
                                    style={{ width: '100%' }}
                                    placeholder="Elegir sexo"
                                    onChange={(value) => {
                                      handleFormChange(value, 'sexo');
                                    }}
                                  >
                                    <Option value="Masculino">Masculino</Option>
                                    <Option value="Femenino">Femenino</Option>
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Estado civil"
                                  name="estadoCivil"
                                  rules={[{ required: true }]}
                                >
                                  <Select
                                    style={{ width: '100%' }}
                                    placeholder="Elegir un estado civil"
                                    onChange={(e) => {
                                      handleFormChange(e, 'estadoCivil');
                                    }}
                                  >
                                    {ESTADOS.map(({ descripcion }) => (
                                      <Option
                                        key={descripcion}
                                        value={descripcion}
                                      >
                                        {descripcion}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Lugar Nacimiento"
                                  name="lugarNacimiento"
                                >
                                  <Input
                                    placeholder="Ingrese un valor"
                                    // value={fields.lugarNacimiento}
                                    onChange={(e) =>
                                      handleFormChange(
                                        e.target.value,
                                        'lugarNacimiento'
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Fecha Nacimiento"
                                  name="fechaNacimiento"
                                  rules={[{ required: true }]}
                                  onChange={onChangeDatePicket}
                                >
                                  <CustomDatePicker
                                    style={{ width: '100%' }}
                                    placeholder="DD/MM/YYYY"
                                    format="DD/MM/YYYY"
                                    onChange={(value) => {
                                      handleFormChange(
                                        value,
                                        'fechaNacimiento'
                                      );
                                      changeData('fechaNacimiento', value);
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                            </>
                          )}

                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Cargo"
                              name="cargo"
                              rules={[{ required: true }]}
                            >
                              <Input
                                placeholder="Ingrese un valor"
                                onChange={(e) =>
                                  handleFormChange(e.target.value, 'cargo')
                                }
                              />
                            </Form.Item>
                          </Col>

                          <br />
                        </Row>
                      </>
                    )}

                    {empresa.seprelad && (
                      <>
                        {!esJuridica && (
                          <>
                            <Divider>Confirme sus Datos Laborales</Divider>
                            <Row
                              gutter={[16, 0]}
                              style={{
                                maxWidth,
                                margin: 'auto',
                                textAlign: 'start'
                              }}
                            >
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Profesión / Ocupación"
                                  name="profesion"
                                  rules={[{ required: true }]}
                                >
                                  <Input
                                    placeholder="Ej.: Comerciante, Abogado/a, Electricista, etc."
                                    // value={fields.profesion}
                                    onChange={(e) =>
                                      handleFormChange(
                                        e.target.value,
                                        'profesion'
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Rango de Ingresos Mensuales Personales (Gs.)"
                                  name="ingresos"
                                  rules={[{ required: true }]}
                                >
                                  <Radio.Group
                                    value={fields.ingresos}
                                    onChange={(e) => {
                                      handleFormChange(
                                        e.target.value,
                                        'ingresos'
                                      );
                                    }}
                                  >
                                    <Radio style={radioStyle} value="1">
                                      1.000.000 a 5.000.000
                                    </Radio>
                                    <Radio style={radioStyle} value="2">
                                      5.000.000 a 10.000.000
                                    </Radio>
                                    <Radio style={radioStyle} value="3">
                                      10.000.000 a 15.000.000
                                    </Radio>
                                    <Radio style={radioStyle} value="4">
                                      Más de 15.000.000
                                    </Radio>
                                  </Radio.Group>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="¿Es Proveedor del Estado?"
                                  name="proveedorEstado"
                                  valuePropName="checked"
                                >
                                  <Switch
                                    checked={fields.proveedorEstado}
                                    onChange={(e) => {
                                      handleFormChange(e, 'proveedorEstado');
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="¿Es una Persona Políticamente Expuesta?"
                                  name="politicamenteExpuesto"
                                  valuePropName="checked"
                                >
                                  <Switch
                                    checked={fields.politicamenteExpuesto}
                                    onChange={(e) => {
                                      handleFormChange(
                                        e,
                                        'politicamenteExpuesto'
                                      );
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Tipo de Trabajo"
                                  name="trabajo"
                                  rules={[{ required: true }]}
                                >
                                  <Select
                                    // value={fields.trabajo}
                                    style={{ width: '100%' }}
                                    placeholder="Elegir trabajo"
                                    onChange={(value) => {
                                      handleFormChange(value, 'trabajo');
                                    }}
                                  >
                                    <Option value="empleadoPublico">
                                      Empleado público
                                    </Option>
                                    <Option value="dependiente">
                                      Dependiente
                                    </Option>
                                    <Option value="independiente">
                                      Independiente
                                    </Option>
                                    <Option value="jubilado">Jubilado</Option>
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  shouldUpdate={(prevValues, curValues) =>
                                    prevValues.politicamenteExpuesto !==
                                    curValues.politicamenteExpuesto
                                  }
                                >
                                  {() =>
                                    form.getFieldValue(
                                      'politicamenteExpuesto'
                                    ) && (
                                      <>
                                        <Form.Item
                                          label="Cargo / Vínculo"
                                          name="vinculo"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                'Este campo es obligatorio'
                                            }
                                          ]}
                                        >
                                          <Input
                                            placeholder="Mencione el cargo o vínculo"
                                            onChange={(e) => {
                                              handleFormChange(
                                                e.target.value,
                                                'vinculo'
                                              );
                                            }}
                                          />
                                        </Form.Item>
                                        <Form.Item
                                          label="Entidad"
                                          name="entidad"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                'Este campo es obligatorio'
                                            }
                                          ]}
                                        >
                                          <Input
                                            placeholder="Ingrese entidad"
                                            onChange={(e) => {
                                              handleFormChange(
                                                e.target.value,
                                                'entidad'
                                              );
                                            }}
                                          />
                                        </Form.Item>
                                        <Form.Item
                                          label="Periodo"
                                          name="periodo"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                'Este campo es obligatorio'
                                            }
                                          ]}
                                        >
                                          <RangePicker
                                            format="DD/MM/YYYY"
                                            onChange={(e) => {
                                              handleFormChange(e, 'periodo');
                                            }}
                                          />
                                        </Form.Item>
                                      </>
                                    )
                                  }
                                </Form.Item>
                              </Col>
                            </Row>
                          </>
                        )}
                        {fields.trabajo &&
                          fields.trabajo !== 'independiente' &&
                          fields.trabajo !== 'jubilado' && (
                            <Divider>
                              Confirme Datos de la Empresa / Empleador
                            </Divider>
                          )}

                        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                          {fields.trabajo && !esJuridica && (
                            <>
                              {fields.trabajo === 'empleadoPublico' && (
                                <>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      label="Institución"
                                      name="institucion"
                                      rules={[{ required: true }]}
                                    >
                                      <Input
                                        placeholder="Ingrese un valor"
                                        onChange={(e) =>
                                          handleFormChange(
                                            e.target.value,
                                            'institucion'
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      label="Cargo"
                                      name="cargo"
                                      rules={[{ required: true }]}
                                    >
                                      <Input
                                        placeholder="Ingrese un valor"
                                        // value={cargo}
                                        onChange={(e) =>
                                          handleFormChange(
                                            e.target.value,
                                            'cargo'
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      label="Año ingreso"
                                      name="anioIngreso"
                                      rules={[{ required: true }]}
                                    >
                                      <Input
                                        placeholder="Ingrese un valor"
                                        // value={anioIngreso}
                                        onChange={(e) =>
                                          handleFormChange(
                                            e.target.value,
                                            'anioIngreso'
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                </>
                              )}
                              {fields.trabajo !== 'independiente' &&
                                fields.trabajo !== 'jubilado' && (
                                  <>
                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        label="Razón Social de la Empresa / Empleador"
                                        name="empresaEmpleador"
                                        rules={[{ required: true }]}
                                      >
                                        <Input
                                          placeholder="Ingrese un valor"
                                          // value={empresaEmpleador}
                                          onChange={(e) => {
                                            handleFormChange(
                                              e.target.value,
                                              'empresaEmpleador'
                                            );
                                          }}

                                          // onBlur={(e) => { buscarRuc(e.target.value); }}
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        label="RUC de la Empresa / Empleador"
                                        name="rucEmpleador"
                                        rules={[
                                          {
                                            pattern: '^[0-9]{5,8}-[0-9]{1}$',
                                            message:
                                              'Verificar formato. Ej.: 12345678-9'
                                          }
                                        ]}
                                        validateTrigger="onBlur"
                                      >
                                        <Input
                                          placeholder="Ej.: 12345678-9 - OPCIONAL"
                                          // value={rucEmpleador}
                                          onChange={(e) => {
                                            const ruc = e.target.value;
                                            handleFormChange(
                                              ruc,
                                              'rucEmpleador'
                                            );
                                            if (
                                              ruc &&
                                              ruc.match(/^[0-9]{5,8}-[0-9]{1}$/)
                                            ) {
                                              debounceRucSet(ruc);
                                            }
                                          }}
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12} align="start">
                                      <Form.Item
                                        label="Nro de Teléfono de la Empresa / Empleador"
                                        onKeyPress={validarCaracterTelefono}
                                        onPaste={validarCaracterTelefono}
                                      >
                                        <Input.Group compact>
                                          <Form.Item
                                            name={[
                                              'telefonoGrupoEmpleador',
                                              'prefijoTelefono'
                                            ]}
                                            rules={[
                                              {
                                                min: 3,
                                                message:
                                                  'Como mínimo debe contener 3 dígitos'
                                              },
                                              {
                                                max: 4,
                                                message:
                                                  'Como máximo debe contener 4 dígitos'
                                              }
                                            ]}
                                            noStyle
                                          >
                                            <Input
                                              placeholder="0531"
                                              style={{ width: '25%' }}
                                              onChange={(e) => {
                                                setPrefijoTelEmpleador(
                                                  e.target.value
                                                );
                                              }}
                                            />
                                          </Form.Item>
                                          <Form.Item
                                            name={[
                                              'telefonoGrupoEmpleador',
                                              'sufijoTelefono'
                                            ]}
                                            rules={[
                                              {
                                                min: 5,
                                                message:
                                                  'Como mínimo debe contener 5 dígitos'
                                              }
                                            ]}
                                            noStyle
                                          >
                                            <Input
                                              placeholder="000 000"
                                              style={{ width: '75%' }}
                                              onChange={(e) => {
                                                setSufijoTelEmpleador(
                                                  e.target.value
                                                );
                                              }}
                                            />
                                          </Form.Item>
                                        </Input.Group>
                                      </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        label="Celular de la Empresa / Empleador"
                                        name="celularEmpleador"
                                        rules={[
                                          {
                                            pattern: `^\\((${prefijos3Digitos.join(
                                              '|'
                                            )})\\) [0-9]{3}-[0-9]{3}$`,
                                            message: 'Número no válido'
                                          }
                                        ]}
                                      >
                                        <InputMask
                                          mask="(999) 999-999"
                                          placeholder="(___) ___-___ - OPCIONAL"
                                          addonBefore={fields.prefix}
                                          onChange={(e) =>
                                            handleFormChange(
                                              e.target.value,
                                              'celularEmpleador'
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>

                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        label="Dirección de la Empresa / Empleador"
                                        name="direccionEmpleador"
                                        rules={[{ required: true }]}
                                      >
                                        <Input
                                          placeholder="Ingrese un valor"
                                          // value={direccionEmpleador}
                                          onChange={(e) =>
                                            handleFormChange(
                                              e.target.value,
                                              'direccionEmpleador'
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                  </>
                                )}
                            </>
                          )}
                        </Row>
                      </>
                    )}
                  </>

                  {vigenciaSugeridaConfig && (
                    <>
                      <Divider>Confirme sus datos de Vigencia y Pagos</Divider>
                      {vigenciaPagosContext &&
                        vigenciaPagosContext.validaciones &&
                        vigenciaPagosContext.validaciones.length > 0 && (
                          <LabelValidateMessage
                            message={
                              vigenciaPagosContext.validaciones[0]
                                .mostrarAlerta &&
                              vigenciaPagosContext.validaciones[0].mensaje
                            }
                          />
                        )}

                      <div>
                        <VigenciaForm
                          vigenciaSugeridaConfig={vigenciaSugeridaConfig}
                          vigenciaByAseguradoraList={[vigenciaPagosContext]}
                          withForm={form}
                          center
                        />
                      </div>
                    </>
                  )}

                  <Divider>Calendario de Pagos propuesto</Divider>

                  <Spin spinning={loadingPlanes} size="large">
                    <CalendarioPagosForm
                      plan={getSelectedPlan()}
                      moneda={moneda}
                    />
                  </Spin>

                  <Divider>Opciones de pago</Divider>
                  <br />

                  <Row
                    gutter={[16, 0]}
                    style={{
                      maxWidth,
                      marginTop: 'auto',
                      marginBottom: 'auto',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      textAlign: 'start'
                    }}
                  >
                    {/* <Col xs={24} md={12}>
                      <Form.Item
                        label="Opción de pago"
                        name="formaPago"
                        rules={[{ required: true }]}
                      >
                        <FormaPago
                          handleFormChange={handleFormChange}
                          formaPago={fields.formaPago}
                          form={form}
                        />
                      </Form.Item>
                    </Col> */}
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Medio de pago"
                        name="metodoPago"
                        rules={[{ required: true }]}
                      >
                        <MetodoPago
                          handleFormChange={(e, field) => {
                            handleFormChange(e, field);
                            form.setFieldsValue({ [field]: e });
                          }}
                          form={form}
                          metodoPago={fields.metodoPago}
                          listaMetodoPago={cotizaciones
                            .find((c) => c.id === selectedCotizacion)
                            .aseguradoraEmpresaProducto.empresaProductoMetodo.map(
                              ({ metodoPago }) => metodoPago
                            )}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row
                    gutter={[16, 0]}
                    style={{
                      maxWidth,
                      margin: 'auto',
                      textAlign: 'start'
                    }}
                  >
                    <Col
                      xs={24}
                      md={24}
                      align="start"
                      style={{ textAlign: 'left' }}
                    >
                      <Form.Item label="Endoso a favor de:">
                        <Switch
                          checked={endosoSwitch.endoso}
                          checkedChildren="Si"
                          unCheckedChildren="No"
                          onChange={() => {
                            setEndosoSwitch({
                              ...endosoSwitch,
                              endoso: !endosoSwitch.endoso
                            });
                          }}
                          style={{
                            marginTop: '6px',
                            marginRight: '16px'
                          }}
                        />
                        {endosoSwitch.endoso && (
                          <Form.Item
                            name="endoso"
                            rules={[{ required: true, message: 'Requerido' }]}
                            style={{
                              display: 'inline-block',
                              width: `calc(${'90%'} - 50px)`
                            }}
                          >
                            <Input
                              placeholder="Especificar respuesta"
                              onChange={(value) => {
                                handleFormChange(value.target.value, 'endoso');
                              }}
                            />
                          </Form.Item>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>

                  <Button
                    style={{ margin: 10 }}
                    onClick={() => setCurrent(current - 1)}
                  >
                    Anterior
                  </Button>
                  <Button
                    style={{ margin: 10 }}
                    type="primary"
                    htmlType="submit"
                    onClick={() => {
                      fields.telefonoEmpleador = concatTelefono(
                        prefijoTelEmpleador,
                        sufijoTelEmpleador
                      );
                      fields.tercero.telefono = concatTelefono(
                        prefijoTelefono,
                        sufijoTelefono
                      );

                      const nombreForm = form
                        .getFieldValue('nombre')
                        ?.toUpperCase();
                      const apellidoForm = form
                        .getFieldValue('apellido')
                        ?.toUpperCase();

                      const nombreApellido = `${apellidoForm}, ${nombreForm}`;
                      handleFormChange(nombreApellido, 'nombres');
                    }}
                  >
                    Confirmar
                  </Button>
                </Form>
              )}
              {current === 3 && (
                <Spin
                  spinning={principalLoading}
                  delay={500}
                  size="large"
                  tip="Procesando la información ingresada. Aguarde un momento."
                  style={{
                    position: 'fixed',
                    left: marginLeft,
                    right: 0,
                    transform: `translate(calc(50vw - 50%), calc(50vh - 50%))`
                  }}
                >
                  <div
                    style={{
                      maxWidth,
                      marginTop: 'auto',
                      marginBottom: 'auto',
                      marginLeft: 'auto',
                      marginRight: 'auto'
                    }}
                  >
                    <>
                      <Descriptions
                        title="Datos del Vehículo"
                        style={{ textAlign: 'left' }}
                        bordered
                        size="small"
                        column={{ md: 2, sm: 1, xs: 1 }}
                        labelStyle={{ width: '20%' }}
                        contentStyle={{ width: '30%' }}
                      >
                        <Descriptions.Item label="Marca">
                          {
                            marcas.filter((m) => m.id === fields.marca)[0]
                              .descripcion
                          }
                        </Descriptions.Item>
                        <Descriptions.Item label="Modelo">
                          {
                            modelos.filter((m) => m.id === fields.modelo)[0]
                              .descripcion
                          }
                        </Descriptions.Item>
                        <Descriptions.Item label="Submodelo">
                          {
                            submodelos.filter(
                              (m) => m.id === fields.submodelo
                            )[0].descripcion
                          }
                        </Descriptions.Item>
                        <Descriptions.Item label="Año">
                          {fields.anio}
                        </Descriptions.Item>
                        <Descriptions.Item label="Monto">
                          {fields.monto}
                        </Descriptions.Item>
                        <Descriptions.Item label="Chassis">
                          {fields.chassis}
                        </Descriptions.Item>
                        <Descriptions.Item label="Chapa">
                          {fields.chapa}
                        </Descriptions.Item>
                      </Descriptions>
                      {tieneAutorizacionPorTipo('ZONA') && (
                        <Descriptions
                          title="Datos de la Zona Principal de Circulación"
                          style={{ textAlign: 'left', marginTop: 20 }}
                          column={{ md: 2, sm: 1, xs: 1 }}
                          bordered
                          size="small"
                        >
                          <Descriptions.Item label="Departamento">
                            {departamentos.find((d) =>
                              d.id === fields.departamentoZonaCirculacion
                                ? Number(fields.departamentoZonaCirculacion)
                                : null
                            )?.descripcion || 'N/A'}
                          </Descriptions.Item>

                          <Descriptions.Item label="Ciudad">
                            {distritosZonaCirculacion.find(
                              (d) => d.id === fields.distritoZonaCirculacion
                            )?.descripcion || 'N/A'}
                          </Descriptions.Item>
                        </Descriptions>
                      )}
                      {esJuridica && (
                        <Descriptions
                          title="Datos de Asegurado"
                          style={{ textAlign: 'left', marginTop: 20 }}
                          column={{ md: 2, sm: 1, xs: 1 }}
                          bordered
                          size="small"
                        >
                          <Descriptions.Item label="Razón Social" span={2}>
                            {fields.empresaJuridica.razon}
                          </Descriptions.Item>
                          <Descriptions.Item label="CI / RUC">
                            {fields.empresaJuridica.ruc}
                          </Descriptions.Item>

                          <Descriptions.Item label="Dirección" span={2}>
                            {fields.empresaJuridica.domicilio}
                          </Descriptions.Item>
                          <Descriptions.Item label="Correo">
                            {fields.empresaJuridica.correo}
                          </Descriptions.Item>
                        </Descriptions>
                      )}
                      <Descriptions
                        title={
                          esJuridica
                            ? 'Datos Personales del REPRESENTANTE LEGAL / FIRMANTE'
                            : 'Datos de Asegurado'
                        }
                        style={{ textAlign: 'left', marginTop: 20 }}
                        bordered
                        size="small"
                        column={{ md: 2, sm: 1, xs: 1 }}
                      >
                        <Descriptions.Item label="Nombre y Apellido" span={2}>
                          {fields.nombres}
                        </Descriptions.Item>
                        <Descriptions.Item label="Cédula">
                          {fields.cedula}
                        </Descriptions.Item>
                        {(!esJuridica || (empresa.seprelad && esJuridica)) && (
                          <Descriptions.Item label="RUC">
                            {fields.ruc}
                          </Descriptions.Item>
                        )}
                        <Descriptions.Item label="Celular">
                          +595{fields.celular}
                        </Descriptions.Item>
                        {(!esJuridica || (empresa.seprelad && esJuridica)) && (
                          <>
                            <Descriptions.Item label="Correo">
                              {fields.correo}
                            </Descriptions.Item>
                            <Descriptions.Item label="Departamento">
                              {departamentos.find(
                                (d) => d.id === fields.departamento
                              )?.descripcion || 'N/A'}
                            </Descriptions.Item>
                            <Descriptions.Item label="Ciudad">
                              {distritos.find((d) => d.id === fields.distrito)
                                ?.descripcion || 'N/A'}
                            </Descriptions.Item>
                            <Descriptions.Item label="Domicilio" span={2}>
                              {fields.domicilio}
                            </Descriptions.Item>
                            <Descriptions.Item label="Sexo">
                              {fields.sexo}
                            </Descriptions.Item>
                            <Descriptions.Item label="Estado civil">
                              {fields.estadoCivil}
                            </Descriptions.Item>
                            <Descriptions.Item label="Fecha nacimiento">
                              {fields.fechaNacimiento &&
                                fields.fechaNacimiento.format('DD/MM/YYYY')}
                            </Descriptions.Item>

                            <Descriptions.Item label="Nacionalidad">
                              {fields.nacionalidad}
                            </Descriptions.Item>
                            <Descriptions.Item label="Lugar nacimiento">
                              {fields.lugarNacimiento}
                            </Descriptions.Item>
                          </>
                        )}
                        {esJuridica && (
                          <Descriptions.Item label="Cargo">
                            {fields.cargo}
                          </Descriptions.Item>
                        )}
                      </Descriptions>

                      <Descriptions
                        title="Datos de Facturación"
                        style={{ textAlign: 'left', marginTop: 20 }}
                        column={{ md: 2, sm: 1, xs: 1 }}
                        bordered
                        size="small"
                      >
                        <Descriptions.Item label="Razón Social" span={2}>
                          {fields.tercero.nombres}
                        </Descriptions.Item>
                        <Descriptions.Item label="CI / RUC">
                          {fields.tercero.ruc}
                        </Descriptions.Item>
                        <Descriptions.Item label="Correo">
                          {fields.tercero.correo}
                        </Descriptions.Item>

                        <Descriptions.Item label="Departamento">
                          {departamentos.find(
                            (d) => d.id === fields.tercero.id_departamento
                          )?.descripcion || 'N/A'}
                        </Descriptions.Item>

                        <Descriptions.Item label="Ciudad">
                          {distritosTercero.find(
                            (d) => d.id === fields.tercero.id_distrito
                          )?.descripcion || 'N/A'}
                        </Descriptions.Item>

                        <Descriptions.Item label="Dirección" span={2}>
                          {fields.tercero.domicilio}
                        </Descriptions.Item>
                        <Descriptions.Item label="Celular">
                          {fields.tercero.celular &&
                            `+595${fields.tercero.celular}`}
                        </Descriptions.Item>
                        <Descriptions.Item label="Teléfono (Línea Baja)">
                          {fields.tercero.telefono}
                        </Descriptions.Item>
                      </Descriptions>
                    </>
                    {empresa.seprelad && !esJuridica && (
                      <>
                        <br />
                        <Descriptions
                          title="Datos Laborales"
                          style={{ textAlign: 'left', marginTop: 20 }}
                          bordered
                          size="small"
                          column={{ md: 2, sm: 1, xs: 1 }}
                        >
                          <Descriptions.Item label="RUC">
                            {fields.ruc}
                          </Descriptions.Item>
                          <Descriptions.Item label="Rango de Ingresos Mensuales Personales (Gs.)">
                            {getDescripcionesIngreso(fields.ingresos)}
                          </Descriptions.Item>
                          <Descriptions.Item label="¿Es Proveedor del estado?">
                            {fields.proveedorEstado ? 'Sí' : 'No'}
                          </Descriptions.Item>
                          <Descriptions.Item label="Tipo empleado">
                            {fields.trabajo?.toUpperCase()}
                          </Descriptions.Item>
                          <Descriptions.Item label="¿Es una Persona Políticamente Expuesta?">
                            {fields.politicamenteExpuesto ? 'Sí' : 'No'}
                          </Descriptions.Item>
                          {fields.politicamenteExpuesto && (
                            <>
                              <Descriptions.Item label="Cargo / Vínculo">
                                {fields.vinculo}
                              </Descriptions.Item>
                              <Descriptions.Item label="Entidad">
                                {fields.entidad}
                              </Descriptions.Item>
                              <Descriptions.Item label="Periodo">
                                {fields.periodo[0]?.format('DD/MM/YYYY')} -{' '}
                                {fields.periodo[1]?.format('DD/MM/YYYY')}
                              </Descriptions.Item>
                            </>
                          )}
                          {fields.institucion && (
                            <>
                              <Descriptions.Item label="Institución Pública">
                                {fields.institucion || 'N/A'}
                              </Descriptions.Item>
                              <Descriptions.Item label="Cargo">
                                {fields.cargo}
                              </Descriptions.Item>
                              <Descriptions.Item label="Año ingreso">
                                {fields.anioIngreso}
                              </Descriptions.Item>
                            </>
                          )}
                          {(fields.rucEmpleador || fields.institucion) && (
                            <>
                              <Descriptions.Item label="RUC Empleador">
                                {fields.rucEmpleador || 'A Confirmar'}
                              </Descriptions.Item>
                              <Descriptions.Item label="Empresa">
                                {fields.empresaEmpleador}
                              </Descriptions.Item>
                              <Descriptions.Item label="Teléfono">
                                {fields.telefonoEmpleador || 'A Confirmar'}
                              </Descriptions.Item>
                              <Descriptions.Item label="Celular">
                                {fields.celularEmpleador
                                  ? `+595${fields.celularEmpleador}`
                                  : 'A Confirmar'}
                              </Descriptions.Item>
                              <Descriptions.Item label="Dirección">
                                {fields.direccionEmpleador}
                              </Descriptions.Item>
                            </>
                          )}
                        </Descriptions>
                      </>
                    )}
                    <Descriptions
                      title="Compañía y Forma de pago"
                      style={{ textAlign: 'left', marginTop: 20 }}
                      bordered
                      size="small"
                      column={{ md: 2, sm: 1, xs: 1 }}
                    >
                      <Descriptions.Item label="Aseguradora">
                        {cotizaciones.filter((c) => c.id === selectedCotizacion)
                          .length > 0
                          ? cotizaciones.filter(
                              (c) => c.id === selectedCotizacion
                            )[0].aseguradoraEmpresa.aseguradora.descripcion
                          : 'N/A'}
                      </Descriptions.Item>
                      <Descriptions.Item label="Cuotas">
                        {vigenciaPagosContext?.cantidad_pagos}
                      </Descriptions.Item>
                      <Descriptions.Item label="Medio de pago" span={2}>
                        {
                          cotizaciones
                            .find((c) => c.id === selectedCotizacion)
                            .aseguradoraEmpresaProducto.empresaProductoMetodo.map(
                              ({ metodoPago }) => metodoPago
                            )
                            .find((item) => item.id === fields.metodoPago)
                            .descripcion
                        }
                      </Descriptions.Item>
                    </Descriptions>
                    <div style={{ marginTop: 20 }}>
                      <Vigencia
                        {...{
                          vigenciaPago: vigenciaPagosContext,
                          tipo: 'vehiculo'
                        }}
                      />
                    </div>
                    <div style={{ marginTop: 20 }}>
                      <DescripcionPlan
                        plan={
                          getCarouselData(
                            getTable(
                              [getSelectedPlan()],
                              null,
                              null,
                              producto,
                              null,
                              true,
                              undefined,
                              false,
                              selectedMonedaPlan
                            )
                          )[0]
                        }
                      />
                    </div>
                    <div style={{ marginTop: 20 }}>
                      <CalendarioPagos
                        lista={calendarioPagosContext}
                        moneda={moneda}
                      />
                    </div>
                  </div>
                </Spin>
              )}
              <div className="steps-action">
                {current === steps.length - 1 &&
                  !solicitado &&
                  empresaProducto &&
                  empresaProducto.poliza_impresion && (
                    <Row
                      gutter={[16, 0]}
                      style={{
                        maxWidth,
                        marginTop: 'auto',
                        marginBottom: 'auto',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                    >
                      <Col xs={24} md={12} align="start">
                        <div style={{ marginBottom: '5px' }}>
                          <span>¿Desea póliza impresa?</span>
                        </div>
                        <Switch
                          checked={impresion}
                          onChange={(value) => setImpresion(!!value)}
                        />
                      </Col>
                    </Row>
                  )}
                {current > 0 && current !== 2 && !solicitado && (
                  <Button
                    style={{ margin: 10 }}
                    onClick={onAnterior}
                    disabled={principalLoading}
                  >
                    Anterior
                  </Button>
                )}
                {current < 2 && descripcionProducto && (
                  // amartinez este es el boton siguiente que esta disabled cuando no esta cargado ambos lado cedula verde
                  <Button
                    disabled={loading1 || loading2 || confirmarCedulaLoading}
                    type="primary"
                    style={{ margin: 10 }}
                    onClick={onSiguiente}
                  >
                    {current === 0 ? 'Solicitar' : 'Siguiente'}
                  </Button>
                )}
                {current === steps.length - 1 && !solicitado && (
                  <BotonSiguiente
                    tipoVenta={tipoVenta}
                    solicitar={solicitar}
                    principalLoading={principalLoading}
                    datosOriginales={datosOriginales}
                    token={token}
                    personaViaContacto={cotizacion.persona?.via_contacto}
                    noEsCliente={noEsCliente}
                  />
                )}
              </div>
            </>
          )}
        </Card>
      </ResponsiveContainer>
    </>
  );
};

export default FormNew;
